<template>
  <div class="mj_page flex jb">

    <div class="left_area">
      <div class="left_top">
        <div class="left_nav">
          <div @click="SdLeftClick(item,'leftList')" :class="item.num===navCall?'navSelected':''"
               v-for="item in NavList"
               :key="item.num">
            {{ item.title }}
          </div>
        </div>
        <div class="scrollable-content">
          <div class="toolsIntroduce">
            <div class="left">
              <img src="./img/face.png" alt="">
            </div>
            <div class="right">
              <div>
                功能介绍
              </div>
              <span v-if="navCall===1">
                基于 Stable Diffusion 2.0模型进行绘画创作，能根据文本描述生成逼真图像
              </span>
              <span v-if="navCall===2">
                基于 Stable Diffusion 2.0模型进行绘画创作，根据已有图像生成新的图像
              </span>
              <span v-if="navCall===3">
               高级SD绘画玩法，开放更多参数设置，可根据特定条件生成图像，通过设置参数控制生成效果
              </span>
              <span v-if="navCall===4">
               基于 Stable Diffusion 3.0最新模型进行绘画创作，超强的绘画理解能力，一句话生成高清画质作品
              </span>
            </div>
          </div>
          <div class="describe" v-if="navCall===3">
            <div class="refer_title">
              <div></div>
              上传参考图（必填）
            </div>
            <div>
            </div>
            <div class="Reference_image">
              <el-upload
                  class="upload-demo"
                  drag
                  :action="fileApi+'/api/front/upload/?fdir=mj_iw'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  multiple>
                <div v-if="imageUrl" class="yesUpload">
                  <img :src="imageUrl" alt="" class="yesUpload_img">
                  <div class="yesUpload_icon" @click.stop="imageUrl=''">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="noUpload">
                  <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                  <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                  <div> 只能上传jpg/png文件，且不超过10MB</div>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="describe" v-if="navCall===3">
            <div class="refer_title">
              <div></div>
              条件控制-ControlNet
            </div>
            <div class="ControlNet" @click="showDefeatPopup('showDefeat')">
              <div class="ControlNet_one" v-if="conditionListSelect.length<1">
                添加条件模型
              </div>
              <div v-else class="ControlNet_two">
                <div class="left">
                  <div class="conditionSelect" v-for="(item,index) in conditionListSelect">
                    <span class="reduce">-</span>
                    <span class="title">{{ item.title }} {{ item.scale }}</span>
                    <div class="add">+</div>
                  </div>
                </div>
                <div class="right">
                  选择
                </div>
              </div>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title" v-if="navCall===3">
              <div></div>
              正向提示词-Prompt（选填）
            </div>
            <div class="refer_title" v-if="navCall!=3">
              <div></div>
              绘画描述
            </div>
            <div class="refer_depict">
              <div>
                <textarea class="text" rows="4" v-model="inputVal"
                          placeholder="输入绘画描述词，描述词越详细生成的图片效果更佳~"></textarea>
              </div>
              <div class="depict_switch">
                <div class="switch">
                  <!--                  <el-switch active-color="#5865f2" inactive-color="#53555f" v-model="switch1">-->
                  <!--                  </el-switch>-->
                  <!--                  <span>自动优化咒语</span>-->
                </div>
                <div class="empty" @click="inputVal=''">清空</div>
              </div>
            </div>
          </div>
          <div class="describe" v-if="navCall===3">
            <div class="refer_title">
              <div></div>
              通用底模-checkpoint
            </div>
            <div class="checkpoint">
              <div @click="checkpoint=item.num" :class="checkpoint===item.num?'checkpoint_items':'checkpoint_item'"
                   v-for="item in checkpointList">
                <img :src="item.img" alt="">
                <div>
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>

          <div class="describe" v-if="navCall===3">
            <div class="refer_title">
              <div></div>
              <span style="display: flex;justify-content: space-between;flex:1;">
                <span>融合风格-Lora</span>
                <span @click="showDefeatPopup('loraStyle')"
                      style="color: #b4b9bf;font-size: 14px;cursor:pointer;">+去添加</span>
              </span>
            </div>
            <div class="fusionStyle">
              <div v-if="LoraListSelect.length===0" class="fusionStyle_one" @click="showDefeatPopup('loraStyle')">
                <div class="fusionStyle_oneLeft">
                  <div>点击</div>
                  <div>添加</div>
                </div>
                <div class="fusionStyle_oneRight">
                  <span>叠加风格</span>
                  <div>在底膜的基础上进行风格叠加融合</div>
                </div>
              </div>
              <div v-else class="fusionStyle_two">
                <div class="two_Imgs" v-for="(item,index) in LoraListSelect">
                  <div class="two_Img">
                    <img :src="item.src" alt="">
                    <div class="closes" @click="clickLoraList(item,index,'delete')">
                      <i class="el-icon-error"></i>
                    </div>
                    <div class="title">
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="two_bot">
                    <div @click="clickLoraList(item,index,'reduce')"> -</div>
                    <div>权重 {{ item.scale }}</div>
                    <div @click="clickLoraList(item,index,'adds')"> +</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--       高级参数   -->
          <div class="describe" v-if="navCall===3||navCall===4">
            <div class="refer_title">
              <div></div>
              高级参数
            </div>
            <div class="parameter">
              <div class="parameter_title">
                采样步数-Sampling Steps
              </div>
              <div class="parameter_slider">
                <div class="slider_num">
                  {{ sampLingSteps }}
                </div>
                <div class="slider">
                  <el-slider :min="25" :max="35" v-model="sampLingSteps"></el-slider>
                </div>
              </div>
              <div class="parameter_title">
                提示词相关性-CFG scale
              </div>
              <div class="parameter_slider">
                <div class="slider_num">
                  {{ cfgScale }}
                </div>
                <div class="slider">
                  <el-slider :min="3" :max="7" v-model="cfgScale"></el-slider>
                </div>
              </div>
              <div class="parameter_title">
                负面提示词-Negative Prom
              </div>
              <div class="Negative_Prom">
                <textarea class="Negative_text" v-model.trim="negativeText" placeholder="请输入不想出现的元素" name=""
                          id=""
                          cols="30" rows="10"></textarea>
              </div>

            </div>
          </div>

          <div class="describe" v-if="navCall===2">
            <div class="refer_title">
              <div></div>
              图片选择
            </div>
            <div class="picture_sel">
              <div class="picture_top">
                <div class="upload_img"
                     :style="{border:imageUrl?'none':'1px dashed #cedffe80', backgroundImage: `url(${imageUrl})`,backgroundSize: 'cover', backgroundPosition: 'center', width: '100px', height: '100px' }">

                  <el-upload
                      class="avatar-uploader"
                      :action="fileApi+'/api/front/upload/?fdir=mj_iw'"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                    <div v-if="imageUrl" @click.stop="imageUrl=''" class="hoverImg">
                      <i class="el-icon-delete"></i>
                    </div>


                    <div v-if="!imageUrl" class="noUpload">
                      <div>
                        <i class="el-icon-plus"></i>
                      </div>
                      <div class="noUpload_text">
                        上传文件风格
                      </div>
                    </div>
                  </el-upload>
                </div>
                <div class="style_strength">
                  <div class="strength_top">
                    <span>风格图强度</span><span>{{ value1 }}%</span>
                  </div>
                  <div class="strength_bot">
                    <el-slider color="#5865f2" v-model="value1"></el-slider>
                  </div>
                </div>
              </div>
              <div class="picture_bot">
                <div>
                  <div class="one">锁定人脸特征</div>
                  <div class="two">请确保风格图中包含人脸</div>
                </div>
                <div class="three">
                  <span>关闭</span>
                  <el-switch active-color="#5865f2" inactive-color="#53555f" v-model="switch1">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
          <div class="describe" v-if="navCall===2||navCall===1">
            <div class="refer_title">
              <div></div>
              LORA风格选择
            </div>
            <div class="toolsModelList">
              <div class="music_style">
                <span :class="clickImgStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item)">
                  {{ item.style }}
                </span>
              </div>
              <!--              <div class="music_styleImg" :style="{height:expand?270+'px':'auto'}">-->
              <div class="music_styleImg" :style="{height:clickImgStyle.shou?expand?270+'px':'auto':'auto'}">
                <div @click="clickImgStyle.num=item.num"
                     :class="clickImgStyle.num===item.num? 'item_click':'styleImg_item'"
                     v-for="item in clickImgStyleList" v-if="item.sign.includes(clickImgStyle.sign) ">
                  <img alt="" :src="item.src">
                  <div>
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div class="upDown" @click="expand=!expand" v-if="clickImgStyle.shou">
                <img v-if="expand" alt="" src='./img/down2.png' height="14" width="15"/>
                <img v-if="!expand" alt="" src="./img/upward.png" height="13" width="14"/>
              </div>
            </div>
          </div>
          <div class="describe" v-if="navCall!==3">
            <div class="refer_title">
              <div></div>
              生成尺寸
            </div>
            <div class="img_size">
              <div v-for="item in imgSize" @click="SdLeftClick(item,'size')"
                   :class="imgSizeNum===item.num?'ClickImgSize_item':'imgSize_item'">
                <div class="item_img">
                  <img alt="" :src="item.src"/>
                </div>
                <div class="item_name">
                  {{ item.name }}
                </div>
                <div class="item_title">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title">
              <div></div>
              绘图模式
            </div>
            <div class="drawingMode">
              <div @click="drawingModeNum=item.num" :class="drawingModeNum===item.num?'mode':'itemMode'"
                   v-for="item in drawingMode">
                {{ item.title }}
                <!-- <div class="vip" v-if="item.num===1">
                  VIP限免
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="createButton">
        <div @click="sendMsg()">
          提交任务 <span>（消耗{{ drawingModeNum }}积分）</span>
        </div>
      </div>
    </div>

    <div class="draw_area">
      <div class="draw_area_tips">
        <span class="one">#</span><span class="two">创作中心</span><span class="three">请遵守中华人民共和国网络安全法， 严禁生成涉及政治人物，色情、恐怖等不良内容， 如有违规封号处理</span>
      </div>
      <!--登录前-->
      <!--样例数据开始-->
      <div class="draw_scroll"
           ref="scrollWrap">
        <div class="draw_list"
             v-infinite-scroll="loadMore"
             :infinite-scroll-disabled="noMore || loading"
             v-if="!isLogin||draw_list.length==0">
          <div class="draw_list_item flex jb"
               v-for="(item,index) in sampleSysList"
               :key="index">

            <img src="./img/sd/sd.png"
                 class="avatar"/>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac"><span class="name">Stable Diffusion</span><span
                    class="tag">AI机器人</span><span
                    class="time">{{ item.add_time }}</span></p>
                <div class="flex ac">
                  <p class="delete flex ac"
                     @click="sampleDeleteDraw(item, index)"><img src="./img/delete.svg"/><span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <p class="zh">{{ item.prompt }}</p>

              </div>
              <template v-if="item.progress < 100">
                <div class="detail_loading msg-item-content">
                  <circleloading></circleloading>
                  <div class="loading_text">SD 绘图需要极大的计算量，请耐心等待...</div>
                </div>
                <div class="creating_progress"
                     v-if="item.progress > 0">
                  <div class="progress_bar">
                    <div class="progress_line"
                         :style="{'width':item.progress+'%'}"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
              </template>
              <div v-else>
                <!-- 绘画 完成 -->
                <div class="big_img" v-if="item.img_url">
                  <!-- 展示图片 -->
                  <div class="msg_img_wrap mg_video_box" v-if="item.img_type=='img_video'">
                    <div class="mg_video_item">
                      <video class="videoBox" :poster="item.raw_img_url" controls>
                        <source :src="item.img_url" type="video/mp4">
                      </video>
                      <!-- <button id="playButton" class="play-btn">▶</button> -->
                    </div>
                  </div>
                  <div class="msg_img_wrap" v-else>
                    <el-image style="display:block;max-width: 400px;"
                              @click.prevent="clickImage(item.raw_img_url)"
                              :src="item.img_url "
                              :preview-src-list="[item.raw_img_url ]"
                    >
                    </el-image>
                    <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                  </div>
                  <!-- 展示图片 -->
                </div>
                <div class="creating_progress" v-if="item.progress > 0 && item.status < 2">
                  <div class="progress_bar">
                    <div class="progress_line" :style="{ 'width': item.progress + '%' }"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
                <template v-else>

                  <div class="options" v-if="item.menu_type == 1">
                    <!-- U V C -->
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>编辑：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="U按钮查看图像，生成所选图像的更大版本并添加更多细节，可进行局部重绘，无损放大，调整创作等。消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="drawImgUV('u', i, item, status)"
                            :class="['btn', { 'disabled': status >= 1 }]"
                            v-for="(status, i) in item.u_code">U{{ i + 1 }}</span>
                      <span @click="imgRedraw(item)" :class="['btn', 'redraw']"><img
                          src="./img/icon_img41.png" alt=" "/></span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>查看：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="C按钮查看当前四图中所对应的单图图片。无消耗"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="viewImg(item, 1)">C1</span>
                      <span @click="viewImg(item, 2)">C2</span>
                      <span @click="viewImg(item, 3)">C3</span>
                      <span @click="viewImg(item, 4)">C4</span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <mgcPop :item="item" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
                    </div>
                  </div>
                  <div class="options" v-if="item.menu_type == 3 ">

                    <div class="options_list flex ac">
                      <p>调整：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="以某张图片为基础进行调整，可进行局部重绘，再继续编辑创作，消耗4积分。"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('upscale_creative', item)">
                        <img src="./img/wand.png" alt=" "/>微调（强）
                      </span>
                      <span class="span" @click="drawImgZoom('upscale_subtle', item)">
                        <img src="./img/wand.png" alt=" "/>微调（弱）
                      </span>
                      <span class="span" @click="openDrowShow('img_region_variation', item)">
                                              <img src="./img/pen.png" alt=" "/>局部重绘
                                            </span>
                    </div>
                    <div class="options_list flex ac">
                      <p>放大：</p>
                      <el-tooltip class="item" effect="dark" content="对当前图片进行缩放，消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('upscale_4x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 2.5x</span>
                      <span class="span" @click="drawImgZoom('upscale_3x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 2x</span>
                      <span class="span" @click="drawImgZoom('upscale_2x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 1.5x</span>
                    </div>

                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <mgcPop :item="item" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
                    </div>
                  </div>


                </template>
                <div style="color: #F0B132;margin-top: 10px;font-size: 14px;"
                     @click="handle_show_feedback_popup(item)">
                  出{{ item.img_type == 'img_video' ? '视频' : '图' }}不满意？点击反馈
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例数据结束-->
        <!-- </div>
    <div class="draw_scroll"> -->
        <!--        登录过后-->
        <div class="draw_list"
             v-infinite-scroll="loadMore"
             :infinite-scroll-disabled="noMore || loading">
          <div class="draw_list_item flex jb"
               v-for="(item,index) in draw_list"
               :key="index">
            <img src="./img/sd/sd.png"
                 class="avatar"/>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac"><span class="name">Stable Diffusion</span><span
                    class="tag">AI-Bot</span> <span class="mgTitp" v-if="item.img_type=='img_video'">魔法</span> <span
                    class="time">{{ item.add_time }}</span>
                  <!-- ID:{{item.draw_id }} -->
                </p>
                <div class="flex ac">
                  <p class="delete flex ac"
                     @click="share_draw_item(item, index)"><img class="share"
                                                                src="./img/icon_img48.png"/><span>分享</span></p>
                  <template
                      v-if="(item.img_type=='img_c'||item.img_type=='img_v'||item.img_type.indexOf('zoom')>0||item.img_type.indexOf('_pan_')>0||item.img_type.indexOf('_variation')>0) && item.status==2">
                    <p class="delete flex ac"
                       v-if="item.is_public==0"
                       @click="pulic_draw_item(item, index)"><img src="./img/prasie.png"/><span>推荐到广场</span></p>
                    <p class="delete flex ac"
                       v-else
                       style="color: #f0b132;"
                       @click="pulic_draw_item(item, index)"><img src="./img/prasie-fill.png"/><span>已推荐到广场</span>
                    </p>
                  </template>
                  <!-- <p class="delete flex ac"
                     v-if="item.cate_id==0"
                     @click="fave_draw_item(item,index)"><img src="./img/favorites.svg"/><span>采集</span></p> -->
                  <p class="delete flex ac" v-if="item.img_type=='img_video'" @click="down(item)">
                    <img src="./img/favorites.svg"/><span>下载</span></p>
                  <p class="delete flex ac"
                     @click="delete_draw_list(item.draw_id, index)"><img src="./img/delete.svg"/><span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <p class="zh">{{ item.prompt }}</p>
              </div>
              <div class="create_error" v-loading="item.regenerateload"
                   v-if="(item.status == 3)&&(item.retry_num<3 && item.is_retry==0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="./img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_text2" @click="regenerate(item,index)">点此重新生成</div>
                <div class="error_text3">（成功率在90%以上）</div>
                <div class="error_text4">涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
              </div>
              <div class="create_error create_error_old"
                   v-else-if="(item.status == 3)&&(item.retry_num>=3 || item.is_retry!=0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="./img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
                <!-- <div class="error_text2" @click="regenerate(item)">点此重新生成</div>
                <div class="error_text3">（成功率在90%以上）</div> -->
                <div class="error_text4">涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
                <!--                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>-->
              </div>
              <template v-else-if="item.status < 2">
                <div class="detail_loading msg-item-content">
                  <circleloading></circleloading>
                  <div class="loading_text"
                       v-if="item.progress <= 0">Stable Diffusion 正在全力出图中，请稍等...
                  </div>
                </div>
                <div class="creating_progress"
                     v-if="item.progress > 0">
                  <div class="progress_bar">
                    <div class="progress_line"
                         :style="{'width':item.progress+'%'}"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
              </template>
              <div v-else>
                <!-- 绘画 完成 -->
                <div class="big_img" v-if="item.img_url">
                  <!-- 展示图片 -->
                  <div class="msg_img_wrap mg_video_box" v-if="item.img_type=='img_video'">
                    <div class="mg_video_item">
                      <video class="videoBox" :poster="item.raw_img_url" controls>
                        <source :src="item.img_url" type="video/mp4">
                      </video>
                      <!-- <button id="playButton" class="play-btn">▶</button> -->
                    </div>
                  </div>
                  <div class="msg_img_wrap" v-else>
                    <el-image style="display:block;max-width: 400px;"
                              @click.prevent="clickImage(item.raw_img_url)"
                              :src="item.img_url "
                              :preview-src-list="[item.raw_img_url ]"
                    >
                    </el-image>
                    <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                  </div>
                  <!-- 展示图片 -->
                </div>
                <div class="creating_progress" v-if="item.progress > 0 && item.status < 2">
                  <div class="progress_bar">
                    <div class="progress_line" :style="{ 'width': item.progress + '%' }"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
                <template v-else>

                  <div class="options" v-if="item.menu_type == 1 && item.img_type!='img_video'">
                    <!-- U V C -->
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>编辑：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="U按钮查看图像，生成所选图像的更大版本并添加更多细节，可进行局部重绘，无损放大，调整创作等。消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="drawImgUV('u', i, item, status)"
                            :class="['btn', { 'disabled': status >= 1 }]"
                            v-for="(status, i) in item.u_code">U{{ i + 1 }}</span>
                      <span @click="imgRedraw(item)" :class="['btn', 'redraw']"><img
                          src="./img/icon_img41.png" alt=" "/></span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>查看：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="C按钮查看当前四图中所对应的单图图片。无消耗"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="viewImg(item, 1)">C1</span>
                      <span @click="viewImg(item, 2)">C2</span>
                      <span @click="viewImg(item, 3)">C3</span>
                      <span @click="viewImg(item, 4)">C4</span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <mgcPop :item="item" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
                    </div>
                  </div>
                  <div class="options" v-if="item.menu_type == 3 && item.img_type!='img_video'">
                    <div class="options_list flex ac">
                      <p>调整：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="以某张图片为基础进行调整，可进行局部重绘，再继续编辑创作，消耗4积分。"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('upscale_creative', item)">
                        <img src="./img/wand.png" alt=" "/>微调（强）
                      </span>
                      <span class="span" @click="drawImgZoom('upscale_subtle', item)">
                        <img src="./img/wand.png" alt=" "/>微调（弱）
                      </span>
                      <span class="span" @click="openDrowShow('img_region_variation', item)">
                        <img src="./img/pen.png" alt=" "/>
                        局部重绘
                      </span>
                    </div>
                    <div class="options_list flex ac">
                      <p>放大：</p>
                      <el-tooltip class="item" effect="dark" content="对当前图片进行缩放，消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('upscale_4x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 2.5x</span>
                      <span class="span" @click="drawImgZoom('upscale_3x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 2x</span>
                      <span class="span" @click="drawImgZoom('upscale_2x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 1.5x</span>
                    </div>

                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <mgcPop :item="item" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
                    </div>
                  </div>


                </template>
                <div style="color: #F0B132;margin-top: 10px;font-size: 14px;"
                     @click="handle_show_feedback_popup(item)">
                  出{{ item.img_type == 'img_video' ? '视频' : '图' }}不满意？点击反馈
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="drowPopB" v-if="isDrowShow">
      <div class="imgRemovalPopup">
        <div class="imgbox_top">
          <div>请擦拭需要涂抹的区域</div>
          <div style="cursor: pointer;" @click="saveImage(0)"><i class="el-icon-error"></i></div>
        </div>
        <div class="imgbox_center">
          <div class="apply">
            <span @click="toggleMode('draw')" :class="RemovalMode=='draw'?'spancol':''">涂抹</span>
            <span @click="toggleMode('erase')" :class="RemovalMode=='erase'?'spancol':''"
                  style="margin:0 10px; ">擦拭涂抹</span>
          </div>
          <div class="brush">
            <span>画笔大小</span>
            <div class="slider">
              <el-slider v-model="brushSize"></el-slider>
            </div>
            <div style="width: 20px;">{{ brushSize }}</div>
          </div>
          <div class="clear_btn" @click="clearCanvas()">
            <div>清空</div>
          </div>
        </div>
        <div class="canvas_region">

          <div class="canvas-wrapper">
            <img id="imageOrigin" :src="partForm.iw_url" @load="onImageLoad"
                 :style="{ left: position.x + 'px', top: position.y + 'px',cursor:Dragging_btn?'move':'', }"
                 alt="Image" ref="canvasRecord">
            <canvas id="canMask"
                    :style="{ left: position.x + 'px',
                    top: position.y + 'px',
                    cursor:Dragging_btn?'move':'',
                      }"
                    @mousedown="startDrag"
                    @mouseup="stopDrag"
                    @mouseleave="stopDrag"
                    ref="canvasDisplay" :width="originWidth" :height="originHeight"></canvas>
          </div>
          <div class="brush scoBox">
            <div @click="Dragging_btn=!Dragging_btn" :class="['Dragging',Dragging_btn?'ok_drag':'']">拖动</div>
            <div class="addBtn" @click="updateScale(0)">
              <img src="./img/jian.svg" alt="">
            </div>
            <div class="aocText">{{ parseInt(scale * 100) }}%</div>
            <div class="addBtn" @click="updateScale(1)">
              <img src="./img/jia.svg" alt="">
            </div>
          </div>
        </div>
        <div class="complete_btn">
          <div class="inp_Redraw">
            重绘内容：<input v-model="partForm.prompt" type="text" placeholder="请输入重绘内容">
          </div>
          <div class="fulfil_btn"  v-loading="canvasLoading"  @click="saveImage(1)">完成</div>
        </div>
      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么MJ绘画出图会比较慢？</div>
            <div class="item_answer">
              答：因为MJ绘画与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么绘画会提示失败？</div>
            <div class="item_answer">
              答：因为MJ绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose">好的，我知道了
        </button>
      </div>
    </popup>

    <popup ref="conditionPopup"
           type="center"
           @close="defeatPopClose('showDefeat')">
      <div class="condition_Popup">
        <div class="conditionTop">
          <div>
            条件预处理器选择（{{ conditionListSelect.length }}/2）
          </div>
          <div class="clear" @click="defeatPopClose('showDefeat')">
            <i class="el-icon-error"></i>
          </div>
        </div>
        <div class="conditionTips">
          指定条件控制图生图，最多选择2个哦~
        </div>
        <div class="conditionShow" v-if="conditionListSelect.length>0">
          <div class="conditionSelect" v-for="(item,index) in conditionListSelect">
            <span @click="clickConditionList(item,index,'reduce')" class="reduce">-</span>
            <span class="title">{{ item.title }} {{ item.scale }}</span>
            <div @click="clickConditionList(item,index,'adds')" class="add">+</div>
          </div>
        </div>
        <div class="condition_List">
          <div @click="clickConditionList(item,index,'add')" :class="!item.select?'List_itme':'List_itmes'"
               v-for="(item,index) in conditionList">
            <div class="item_img">
              <img :src="require('./img/sd/condition/0'+(index+1)+'.png')" alt="">
            </div>
            <div class="title">
              <div>{{ item.title }}</div>
              <span>{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="conditionBtn">
          <div @click="clickConditionList('item','index','clear')">重置</div>
          <div @click="defeatPopClose('showDefeat')">确定</div>
        </div>
      </div>
    </popup>

    <popup ref="loraStyle"
           type="center"
           @close="defeatPopClose('loraStyle')">
      <div class="loraStyle_Popup">
        <div class="conditionTop">
          <div>
            融合Lora模型（{{ LoraListSelect.length }} / 2）
          </div>
          <div class="clear" @click="defeatPopClose('loraStyle')">
            <i class="el-icon-error"></i>
          </div>
        </div>
        <div class="conditionTips">
          在主模型的基础上进行风格叠加融合。注意不要融太多和比例太高，容易造成崩图哦~
        </div>
        <div class="conditionShow" v-if="LoraListSelect.length>0">
          <div class="conditionSelect" v-for="(item,index) in LoraListSelect">
            <span @click="clickLoraList(item,index,'reduce')" class="reduce">-</span>
            <span class="title">{{ item.title }} {{ item.scale }}</span>
            <div @click="clickLoraList(item,index,'adds')" class="add">+</div>
          </div>
        </div>
        <div class="music_style">
                <span :class="LoraListStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item,true)">
                  {{ item.style }}
                </span>
        </div>
        <div class="condition_List">
          <!--              <div class="music_styleImg" :style="{height:expand?270+'px':'auto'}">-->
          <div class="music_styleImg">
            <div @click="clickLoraList(item,index,'add')"
                 :class="item.select? 'item_click':'styleImg_item'"
                 v-for="(item,index) in clickImgStyleList" v-if="item.sign.includes(LoraListStyle.sign)">
              <img alt="" :src="item.src">
              <div>
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="conditionBtn">
          <div @click="clickLoraList('','','clear')">重置</div>
          <div @click="defeatPopClose('loraStyle')">确定</div>
        </div>
      </div>
    </popup>

    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw&&show_sharedraw_popup"
               :draw_item="current_draw"
               @close="show_sharedraw_popup=false"
               ref="ShareDraw"></ShareDraw>
    <!--采集-->
    <drawCateEdit ref="drawCateEdit"
                  @close="caiJiOk"></drawCateEdit>
    <!-- C1 查看 -->
    <canvas ref="localCanvas"
            style="display: none;"
            useCORS="true"
            allowTaint="true"></canvas>
    <el-image style="display: none;" ref="previewImg" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image>

    <!-- 提示词弹窗 -->
    <TipsWords v-if="is_show_tips_com"></TipsWords>
    <popup ref="imageManipulation" type="center" @close="drawImgZoom('','','close')">
      <div class="Image_manipulation">
        <div class="clear" @click="drawImgZoom('','','close')">
          <i class="el-icon-error"></i>
        </div>
        <!-- <img :src="liveAlone" alt=""/> -->
        <el-image style="display:block;max-width: 800px;"
                  @click.prevent="clickImage(liveAlone)"
                  :src="liveAlone"
                  :preview-src-list="[liveAlone]">
        </el-image>

      </div>
    </popup>
    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import AdvancedOptions from '@/components/AdvancedOptions'
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu"
import mgcPop from "../components/mgcPop2.vue"
import utils from '@/utils/index.js'

export default {
  components: {
    mgcPop,
    AdvancedOptions,
    popup,
    circleloading,
    FeedBack,
    Recommend,
    ShareDraw,
    drawCateEdit,
    TipsWords,
    faceVerifyPopup
  },
  data() {
    return {
      // kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      //显示个人中心
      show_person_hover: false,
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      //模型列表
      model_list: [{
        name: "MJ5.2",
        title: 'MJ5.2(真实细节)',
        desc: '增强真实风格图像细节'
      }, {
        name: "NJ5.0",
        title: 'NJ5.0(动漫增强)',
        desc: '增强动漫风格图像细节'
      }, {
        name: "MJ5.1",
        title: 'MJ5.1(艺术增强)',
        desc: '专注真实艺术风格图像'
      }, {
        name: "NJ6.0",
        title: 'NJ6.0(动漫质感)',
        desc: '官方最新动漫模型同步',
        is_new: 1
      }, {
        name: "MJ6.0",
        title: 'MJ6.0(真实质感)',
        desc: '全新6.0 ALPHA真实风格图像',
        is_new: 1
      }],

      auto_spell: '1',
      //绘图模式列表
      fastModeList: [{
        is_fast: -1,
        name: '绘图模式',
        src: require('./img/icon_img38.png'),
        is_disabled: true,
        tooltip: '普通模式：高峰期预计需要10分钟出图（非会员4积分，普通会员1积分，高级/超级会员免积分）<br/>快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分）'
      }, {
        is_fast: 1,
        name: '快速模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }, {
        is_fast: 0,
        name: '普通模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }],
      //当前选中模型
      img_model: 'NJ6.0',
      //选中的mode
      fastIndex: 1,
      is_fast: 1,
      //展示隐藏search_tips
      search_tips: false,
      inputVal: '',//输入框数据
      draw_list: [],
      sending: false, // 提交绘画状态
      posting: false,
      settingData: {
        artistry: 0,
        model: 1,
        outrageous: 0,
        ratio: "", // 生成尺寸
      },
      upload_img_url: "",
      img_iw: 2.0, //设定文本提示对图像的影响权重，默认为--iw 0.25
      powerList: {
        0.5: '低',
        1: '默认',
        1.5: '中',
        2: '高'
      },
      upoadLoading: false,
      view_img_url: "",
      split_img_url: "",
      advanceForm: null, // 高级配置参数
      current_draw: null,//当前选中的记录
      Original: '',
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      showDrawTips: localStorage.getItem("showDrawTips") || 0,

      // sd绘画左侧信息
      navCall: 1,
      NavList: [
        {title: '文生图', num: 1,},
        {title: '图生图', num: 2,},
        {title: '条件生图', num: 3,},
        {title: 'SD3', num: 4,},
      ],

      switch1: true,
      musicStyle: [
        {style: '推荐', sign: 1, num: 1, shou: true,},
        {style: '七夕', sign: 2, num: 12, shou: false,},
        {style: '游戏', sign: 3, num: 40, shou: true,},
        {style: '女生', sign: 4, num: 3, shou: true,},
        {style: '男生', sign: 5, num: 59, shou: true,},
        {style: '动漫风', sign: 6, num: 13, shou: true,},
        {style: '3D立体', sign: 7, num: 86, shou: false,},
        {style: '艺术创作', sign: 8, num: 8, shou: true,},
        {style: '中国风', sign: 9, num: 64, shou: false,},
        {style: '建筑设计', sign: 10, num: 105, shou: false,},
        {style: 'LOGO图标', sign: 11, num: 109, shou: false,},
      ],
      clickImgStyle: {num: 1, sign: 1, shou: true,},
      clickImgStyleList: [
        {num: 1, sign: [1], title: '默认动漫', select: false, scale: 0.8, src: require('./img/sd/57.png'),},
        {
          num: 2,
          desc: "MJ6.0",
          sign: [1],
          title: '默认写实',
          select: false,
          scale: 0.8,
          src: require('./img/sd/56.png'),
        },
        {
          num: 3,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '默认摄影',
          select: false,
          scale: 0.8,
          src: require('./img/sd/55.png'),
        },
        {num: 4, sign: [1], title: '默认动漫2.0', select: false, scale: 0.8, src: require('./img/sd/54.png'),},
        {
          num: 5,
          desc: "MJ6.0",
          sign: [1],
          title: '全能模型',
          select: false,
          scale: 0.8,
          src: require('./img/sd/53.png'),
        },
        {
          num: 6,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '东方美女',
          select: false,
          scale: 0.8,
          src: require('./img/sd/52.png'),
        },
        {
          num: 7,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '人与自然',
          select: false,
          scale: 0.8,
          src: require('./img/sd/51.png'),
        },
        {num: 8, sign: [1, 8], title: '机械甲虫', select: false, scale: 0.8, src: require('./img/sd/50.png'),},
        {num: 9, sign: [1, 8], title: '风格悬疑', select: false, scale: 0.8, src: require('./img/sd/49.png'),},
        {num: 10, sign: [1, 8], title: '日式悬疑', select: false, scale: 0.8, src: require('./img/sd/48.png'),},
        {num: 11, sign: [1, 8], title: '中式悬疑', select: false, scale: 0.8, src: require('./img/sd/47.png'),},
        {num: 12, sign: [1, 2], title: '双人插画', select: false, scale: 0.8, src: require('./img/sd/46.png'),},
        {num: 13, sign: [1, 6], title: '轻线条', select: false, scale: 0.8, src: require('./img/sd/45.png'),},
        {num: 14, sign: [1, 6, 8], title: '儿童绘本', select: false, scale: 0.8, src: require('./img/sd/44.png'),},
        {num: 15, sign: [1, 6, 8], title: '像素世界', select: false, scale: 0.8, src: require('./img/sd/43.png'),},
        {num: 16, sign: [1, 8], title: '玉石质感', select: false, scale: 0.8, src: require('./img/sd/42.png'),},
        {num: 17, sign: [1, 6], title: '商业插画', select: false, scale: 0.8, src: require('./img/sd/41.png'),},
        {num: 18, sign: [1, 6], title: '潦草画风', select: false, scale: 0.8, src: require('./img/sd/40.png'),},
        {num: 19, sign: [1, 6], title: '涂鸦风格', select: false, scale: 0.8, src: require('./img/sd/39.png'),},
        {num: 20, sign: [1, 4, 8], title: '炫彩少女', select: false, scale: 0.8, src: require('./img/sd/38.png'),},
        {num: 21, sign: [1, 6], title: '小清新', select: false, scale: 0.8, src: require('./img/sd/37.png'),},
        {num: 22, sign: [1, 8], title: '彩泥幻境', select: false, scale: 0.8, src: require('./img/sd/36.png'),},
        {num: 23, sign: [1, 8], title: '西游神话', select: false, scale: 0.8, src: require('./img/sd/35.png'),},
        {num: 24, sign: [1, 6], title: '治愈动画', select: false, scale: 0.8, src: require('./img/sd/34.png'),},
        {num: 25, sign: [1, 8,], title: '全息科技', select: false, scale: 0.8, src: require('./img/sd/33.png'),},
        {num: 26, sign: [1, 8,], title: '水彩插画', select: false, scale: 0.8, src: require('./img/sd/32.png'),},
        {
          num: 27,
          desc: "MJ6.0",
          sign: [1, 4],
          title: '韩流写真',
          select: false,
          scale: 0.8,
          src: require('./img/sd/31.png'),
        },
        {num: 28, sign: [1, 8,], title: '潮流机械', select: false, scale: 0.8, src: require('./img/sd/30.png'),},
        {num: 29, sign: [1, 8,], title: '跳跃色彩', select: false, scale: 0.8, src: require('./img/sd/29.png'),},
        {num: 30, sign: [1, 2, 8,], title: '玫瑰花海', select: false, scale: 0.8, src: require('./img/sd/28.png'),},
        {num: 31, sign: [1, 2, 6], title: '原谅色', select: false, scale: 0.8, src: require('./img/sd/27.png'),},
        {num: 32, sign: [1, 2, 6], title: '情绪插画', select: false, scale: 0.8, src: require('./img/sd/26.png'),},
        {num: 33, sign: [1, 2, 6], title: '放纵自由', select: false, scale: 0.8, src: require('./img/sd/25.png'),},
        {num: 34, sign: [4], title: '古典敦煌', select: false, scale: 0.8, src: require('./img/sd/58.png'),},
        {
          num: 35,
          desc: "MJ6.0",
          sign: [4],
          title: '港风胶片',
          select: false,
          scale: 0.8,
          src: require('./img/sd/59.png'),
        },
        {
          num: 36,
          desc: "MJ6.0",
          sign: [4],
          title: '霓虹灯光',
          select: false,
          scale: 0.8,
          src: require('./img/sd/60.png'),
        },
        {num: 37, sign: [4], title: '九尾妖狐', select: false, scale: 0.8, src: require('./img/sd/61.png'),},
        {num: 38, sign: [4], title: '狐妖面具', select: false, scale: 0.8, src: require('./img/sd/62.png'),},
        {num: 39, sign: [4], title: '白月光', select: false, scale: 0.8, src: require('./img/sd/63.png'),},
        {num: 40, sign: [3], title: '原-lumine', select: false, scale: 0.8, src: require('./img/sd/64.png'),},
        {num: 41, sign: [3], title: '原-PAIMON', select: false, scale: 0.8, src: require('./img/sd/65.png'),},
        {num: 42, sign: [3], title: '原-YELAN', select: false, scale: 0.8, src: require('./img/sd/66.png'),},
        {num: 43, sign: [3], title: '原-NINGGUANG', select: false, scale: 0.8, src: require('./img/sd/67.png'),},
        {num: 44, sign: [3], title: '原-EULA', select: false, scale: 0.8, src: require('./img/sd/68.png'),},
        {num: 45, sign: [3], title: '原-NILOU', select: false, scale: 0.8, src: require('./img/sd/69.png'),},
        {num: 46, sign: [3], title: '原-BARBARA', select: false, scale: 0.8, src: require('./img/sd/70.png'),},
        {num: 47, sign: [3], title: '原-KEQING', select: false, scale: 0.8, src: require('./img/sd/71.png'),},
        {num: 48, sign: [3], title: '原-YOIMIYA', select: false, scale: 0.8, src: require('./img/sd/72.png'),},
        {num: 49, sign: [3], title: '原-HUTAO', select: false, scale: 0.8, src: require('./img/sd/73.png'),},
        {num: 50, sign: [3], title: '原-MIKO', select: false, scale: 0.8, src: require('./img/sd/74.png'),},
        {num: 51, sign: [3], title: '原-GANYU', select: false, scale: 0.8, src: require('./img/sd/75.png'),},
        {num: 52, sign: [3], title: '原-KOKOMI', select: false, scale: 0.8, src: require('./img/sd/76.png'),},
        {num: 53, sign: [3], title: '原-SHENHE', select: false, scale: 0.8, src: require('./img/sd/77.png'),},
        {num: 54, sign: [3], title: '原-AYAKA', select: false, scale: 0.8, src: require('./img/sd/78.png'),},
        {num: 55, sign: [3], title: '原-KLEE', select: false, scale: 0.8, src: require('./img/sd/79.png'),},
        {num: 56, sign: [3], title: '原-SHOGUN', select: false, scale: 0.8, src: require('./img/sd/80.png'),},
        {num: 57, sign: [3], title: '原-NAHIDA', select: false, scale: 0.8, src: require('./img/sd/81.png'),},
        {num: 58, sign: [3], title: '原-FURINA', select: false, scale: 0.8, src: require('./img/sd/82.png'),},
        {num: 59, sign: [5], title: '正义-警车', select: false, scale: 0.8, src: require('./img/sd/83.png'),},
        {num: 60, sign: [5], title: '正义-跑车', select: false, scale: 0.8, src: require('./img/sd/84.png'),},
        {num: 61, sign: [5], title: '正义-警', select: false, scale: 0.8, src: require('./img/sd/85.png'),},
        {num: 62, sign: [5], title: '正义-小丑', select: false, scale: 0.8, src: require('./img/sd/86.png'),},
        {num: 63, sign: [5], title: '关云长', select: false, scale: 0.8, src: require('./img/sd/87.png'),},
        {num: 64, sign: [5, 9,], title: '古装男神', select: false, scale: 0.8, src: require('./img/sd/88.png'),},
        {num: 65, sign: [5, 6], title: '痞帅男风', select: false, scale: 0.8, src: require('./img/sd/89.png'),},
        {num: 66, sign: [5, 6], title: '治愈男生', select: false, scale: 0.8, src: require('./img/sd/90.png'),},
        {num: 67, sign: [5, 6], title: '厚插画男生', select: false, scale: 0.8, src: require('./img/sd/91.png'),},
        {num: 68, sign: [5], title: '国风少侠', select: false, scale: 0.8, src: require('./img/sd/92.png'),},
        {num: 69, sign: [6,], title: '复古动漫', select: false, scale: 0.8, src: require('./img/sd/93.png'),},
        {num: 70, sign: [6,], title: '冷淡风', select: false, scale: 0.8, src: require('./img/sd/94.png'),},
        {num: 71, sign: [6,], title: '治愈女生', select: false, scale: 0.8, src: require('./img/sd/95.png'),},
        {num: 72, sign: [6,], title: '表情大师', select: false, scale: 0.8, src: require('./img/sd/96.png'),},
        {num: 73, sign: [6,], title: '大乱斗', select: false, scale: 0.8, src: require('./img/sd/97.png'),},
        {num: 74, sign: [6,], title: '卡通手绘', select: false, scale: 0.8, src: require('./img/sd/98.png'),},
        {num: 75, sign: [6,], title: '涂鸦线条', select: false, scale: 0.8, src: require('./img/sd/99.png'),},
        {num: 76, sign: [6,], title: '漫画线条', select: false, scale: 0.8, src: require('./img/sd/100.png'),},
        {num: 77, sign: [6,], title: '沙雕手绘', select: false, scale: 0.8, src: require('./img/sd/101.png'),},
        {num: 78, sign: [6,], title: '龙年头像', select: false, scale: 0.8, src: require('./img/sd/102.png'),},
        {num: 79, sign: [6,], title: '龙年幻彩', select: false, scale: 0.8, src: require('./img/sd/103.png'),},
        {num: 80, sign: [6,], title: '国风扁平插画', select: false, scale: 0.8, src: require('./img/sd/104.png'),},
        {num: 81, sign: [6,], title: 'Q版简绘', select: false, scale: 0.8, src: require('./img/sd/105.png'),},
        {num: 82, sign: [6,], title: '儿童绘本插画', select: false, scale: 0.8, src: require('./img/sd/106.png'),},
        {num: 83, sign: [6,], title: '故事书插画', select: false, scale: 0.8, src: require('./img/sd/107.png'),},
        {num: 84, sign: [6,], title: '幻想机甲', select: false, scale: 0.8, src: require('./img/sd/108.png'),},
        {num: 85, sign: [6,], title: '可爱盲盒', select: false, scale: 0.8, src: require('./img/sd/109.png'),},
        {num: 86, sign: [7,], title: 'Q版3D', select: false, scale: 0.8, src: require('./img/sd/110.png'),},
        {num: 87, sign: [7,], title: '黏土风', select: false, scale: 0.8, src: require('./img/sd/111.png'),},
        {num: 88, sign: [7,], title: 'Q版3D三视图', select: false, scale: 0.8, src: require('./img/sd/112.png'),},
        {num: 89, sign: [7,], title: '3D皮克斯', select: false, scale: 0.8, src: require('./img/sd/113.png'),},
        {num: 90, sign: [7,], title: '3D人物', select: false, scale: 0.8, src: require('./img/sd/114.png'),},
        {num: 91, sign: [8,], title: '头像素描', select: false, scale: 0.8, src: require('./img/sd/115.png'),},
        {num: 92, sign: [8,], title: '毛毡娃娃', select: false, scale: 0.8, src: require('./img/sd/116.png'),},
        {num: 93, sign: [8,], title: '剪纸山水', select: false, scale: 0.8, src: require('./img/sd/117.png'),},
        {num: 94, sign: [8,], title: '西方蛟龙', select: false, scale: 0.8, src: require('./img/sd/118.png'),},
        {num: 95, sign: [8,], title: '东方神龙', select: false, scale: 0.8, src: require('./img/sd/119.png'),},
        {num: 96, sign: [8,], title: '电商产品', select: false, scale: 0.8, src: require('./img/sd/120.png'),},
        {num: 97, sign: [8,], title: '油画', select: false, scale: 0.8, src: require('./img/sd/121.png'),},
        {num: 98, sign: [8,], title: '写实增强', select: false, scale: 0.8, src: require('./img/sd/122.png'),},
        {num: 99, sign: [8,], title: '速写风', select: false, scale: 0.8, src: require('./img/sd/123.png'),},
        {num: 100, sign: [9,], title: '国风盲盒', select: false, scale: 0.8, src: require('./img/sd/124.png'),},
        {num: 101, sign: [9,], title: '美丽风景', select: false, scale: 0.8, src: require('./img/sd/125.png'),},
        {num: 102, sign: [9,], title: '中式风景', select: false, scale: 0.8, src: require('./img/sd/126.png'),},
        {num: 103, sign: [9,], title: '水墨画', select: false, scale: 0.8, src: require('./img/sd/127.png'),},
        {num: 104, sign: [9,], title: '水墨山水', select: false, scale: 0.8, src: require('./img/sd/128.png'),},
        {num: 105, sign: [10,], title: '现代建筑', select: false, scale: 0.8, src: require('./img/sd/129.png'),},
        {num: 106, sign: [10,], title: '轻奢风室内', select: false, scale: 0.8, src: require('./img/sd/130.png'),},
        {num: 107, sign: [10,], title: '通用室内设计', select: false, scale: 0.8, src: require('./img/sd/131.png'),},
        {num: 108, sign: [10,], title: '现代北欧', select: false, scale: 0.8, src: require('./img/sd/132.png'),},
        {num: 109, sign: [11,], title: '高级LOGO', select: false, scale: 0.8, src: require('./img/sd/133.png'),},
        {num: 110, sign: [11,], title: '极简LOGO', select: false, scale: 0.8, src: require('./img/sd/134.png'),},
      ],
      expand: true,
      drawingMode: [
        {num: 2, title: '单图模式',},
        {num: 4, title: '四图模式',},
      ],
      drawingModeNum: 2,
      imgSizeNum: 1,
      imgSize: [
        {num: 1, name: '1:1', title: '头像框', src: require('./img/1^1.png'),},
        {num: 2, name: '1:2', title: '手机壁纸', src: require('./img/1^2.png'),},
        {num: 3, name: '16:9', title: '电脑壁纸', src: require('./img/16^9.png'),},
        {num: 4, name: '9:16', title: '宣传海报', src: require('./img/9^16.png'),},
        {num: 5, name: '4:3', title: '文章配图', src: require('./img/4^3.png'),},
        {num: 6, name: '3:4', title: '媒体配图', src: require('./img/3^4.png'),},
        {num: 7, name: '3:2', title: '横版名片', src: require('./img/3^2.png'),},
        {num: 8, name: '2:3', title: '小红书图', src: require('./img/2^3.png'),},
      ],
      imageUrl: null,
      // imageUrl: 'https://mjimg.zhanjuzhe.cn/mj_iw/202410/28/20241028111623717189.png',
      value1: 60,
      form: {
        iw: 0.025 * this.value1, // 测试sd图生图
        // iw: 0.25 * this.value1 ,
        aspect: "16:9",// 大小比例
        is_public: '0',//是否公开作品
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: []
      },
      //条件控制
      conditionListSelect: [],
      conditionList: [
        {num: 1, scale: 0.8, select: false, title: '线稿渲染Lineart', explain: '按照轮廓绘制，适合草图上色',},
        {num: 2, scale: 0.8, select: false, title: '边缘检测 Canny', explain: '提取线稿进行绘制，更好的保留图片的细节',},
        {num: 3, scale: 0.8, select: false, title: '素描上色 Recolor', explain: '精准保持素描图轮廓进行简笔上色',},
        {num: 4, scale: 0.8, select: false, title: '深度检测 Depth', explain: '根据上传图片的深度信息生成新的图片',},
        {num: 5, scale: 0.8, select: false, title: '软边缘 Hed', explain: '精确保留角色细节，适用于变换服饰和背景',},
        {num: 6, scale: 0.8, select: false, title: '色块分割 Seg', explain: '根据提供的色块进行分割处理',},
        {num: 7, scale: 0.8, select: false, title: '室内设计 M-Lsd', explain: '根据上传图片的深度信息生成新的图片',},
        {
          num: 8,
          scale: 0.8,
          select: false,
          title: '细节增强 Tile',
          explain: '保持构图不变的情况下，对原图的细节进行增强',
        },
        {num: 9, scale: 0.8, select: false, title: '姿态检测 Openpose', explain: '仅用于姿态检测，不检测人脸',},
        {num: 10, scale: 0.8, select: false, title: '脸、手、身体Openpose', explain: '全身的姿态检测，更加完整',},
      ],
      //通用底模
      checkpoint: 1,
      checkpointList: [
        {num: 1, title: '动漫', img: require('./img/sd/57.png'),},
        {num: 2, title: '写实', img: require('./img/sd/56.png'),},
        {num: 3, title: '摄影', img: require('./img/sd/55.png'),},
        {num: 4, title: '动漫2.0', img: require('./img/sd/54.png'),},
        {num: 5, title: '全能模型', img: require('./img/sd/53.png'),},
      ],
      // 融合风格-Lora
      LoraListSelect: [],
      LoraListStyle: {num: 1, sign: 1, shou: true,},
      // 高级参数
      sampLingSteps: 28,
      cfgScale: 4,
      negativeText: '',
      // 上传图片
      fileApi: FILE_API_SERVER,
      page: 1,
      pageType: false,
      currentTimer: new Date(),
      liveAlone: '',
      isDrowShow: false, // 局部调整是否显示
      RemovalMode: 'draw', // 'draw' 或 'erase':false, 局部调整
      originWidth: 0, // 局部调整
      originHeight: 0,// 局部调整
      scale: 0, // 缩放比例 局部调整
      brushSize: 10,// 局部调整
      canvasRecord: null, // 保存 canvas 上下文
      canvasDisplay: null, // 保存 canvas 上下文
      drawnPath: [], // 存储涂抹的路径
      partForm: {
        // 上传图片
        iw_url: '',// 局部调整弹窗图片
        // iw_url: 'https://mjimg.zhanjuzhe.cn/mj_tool/202504/22/20250422170645838015.png',// 局部调整弹窗图片
        // iw_urls: 'https://mjimg.zhanjuzhe.cn/mj_tool/202504/22/20250422170659960514.png',
        prompt: '', // 重绘文字
        parent_draw_id:'',
        img_type:'img_region_variation',
      },
      canvasHeight: 0,
      position: {x: null, y: null},
      // position: {x: 0, y: 0},
      startPos: {x: 0, y: 0},
      Dragging_btn: false,
      isDragging: false,
      Dragging_num: 0,
      Dragging_save: {
        x: 0,
        y: 0,
      },
      clearPath:[],//记录清除轨迹
      canvasLoading:false,
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    is_show_tips_com() {
      return this.$store.state.shou_tips_com
    },
  },
  created() {
    this.sampleUserList = JSON.parse(localStorage.getItem("sampleUserListSd") || "[]")
    this.fetchDataList()
    this.fettchSampleList()
  },
  methods: {
    handleResize() {
      // this.windowHeight = window.innerHeight;
      // this.canvasHeight = this.windowHeight
      if (window.innerHeight >= 900) {
        this.canvasHeight = 650
      } else if (window.innerHeight < 900 && window.innerHeight > 850) {
        this.canvasHeight = 600
      } else if (window.innerHeight < 850 && window.innerHeight > 800) {
        this.canvasHeight = 500
      } else if (window.innerHeight < 800 && window.innerHeight > 750) {
        this.canvasHeight = 400
      } else {
        this.canvasHeight = 400
      }
    },
    mgcPFn(data) {
      this.submitQuestion(data)
    },
    fettchSampleList() {
      // 获取样例数据
      this.$http.get('/front/aisd/draw/sample/', {
        params: {
          max_mj_id: this.max_mj_id,
          page: this.page,
        }
      }).then((res) => {
        this.noMore = false
        this.loading = false
        let _list = res.data.item_list
        this.sampleSelectList = _list.slice(_list.length - 20, _list.length)

        if (this.sampleUserList.length > 0) {
          this.sampleSysList = this.sampleUserList
        } else {
          this.sampleSysList = this.sampleSysList.concat(_list)
        }
        this.sampleSysList.forEach(item => {
          item.menu_type = 3
        })
      })
    },
    sampleDrawImg() {
      // 样例图片 U V 处理
      if (this.isLogin) {
        this.$confirm('当前任务为演示数据，暂不支持该操作，请先执行绘画任务', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.checkLogin()
      }
    },
    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('当前任务为演示数据，暂不支持该操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
      }).catch(() => {
      })
      // this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
      //   type: 'warning'
      // }).then(() => {
      //   this.sampleSysList.splice(index, 1)
      //   let j = -1
      //   for (let i = 0; i < this.sampleUserList.length; i++) {
      //     if (this.sampleUserList[i].draw_id == item.draw_id) {
      //       j = i
      //     }
      //   }
      //   if (j > -1) {
      //     this.sampleUserList.splice(j, 1)
      //     localStorage.setItem("sampleUserListSd", JSON.stringify(this.sampleUserList))
      //   }
      // })
    },


    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },


    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.fetchDataList()
      } else {
        // 未登录请求样例
        // this.pageType = false
        if (this.page >= 3) {
          this.$message.warning('样例已全部加载')
          return
        }
        this.page = this.page + 1
        this.fettchSampleList()
      }
    },
    fetchDataList() {
      // 对话内容
      this.loading = true
      this.$http.get('/front/aisd/user/draw/', {
        params: {
          max_mj_id: this.max_mj_id,
          softs: 'sd',
        },
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            res.data.item_list.forEach(item => {
              if (!item.regenerateload) {
                item.regenerateload = false
              }
            })
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // this.draw_list[0].menu_type = 3
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    //发送消息
    sendMsg() {
      // console.log('实名弹窗')
      // this.$refs.faceVerifyPopup.show()
      // console.log()
      // return;

      // 登录状态
      if (!this.checkLogin()) return
      this.inputVal = this.inputVal.trim();
      // 绘画描述
      if (!this.inputVal && this.navCall !== 3) {
        this.$message.warning('请输入文字信息')
        return
      }
      if (this.navCall === 2) {
        if (this.imageUrl === '' || this.imageUrl === null) {
          this.$message.warning('上传图片')
          return;
        }
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      let parameters = {
        iw: this.value1 * 0.025,
        aspect: this.imgSize[this.imgSizeNum - 1].name,// 大小比例 this.imgSize[this.imgSizeNum+1].name
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: this.navCall === 1 ? [] : [this.imageUrl]
      }
      this.advanceForm = {
        iw: this.value1 * 0.025,
        aspect: this.imgSize[this.imgSizeNum - 1].name,
        is_public: "0",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: this.navCall === 1 ? [] : [{img_url: this.imageUrl}]
      }
      if (this.advanceForm) {
        parameters = this.advanceForm
      } else {
        let _form = this.getCache("formAdvanceParams") || ""
        if (_form) {
          parameters = JSON.parse(_form)
        }
      }

      let fg_tips = ""
      this.$store.state.hav_choose_tips.forEach(m => {
        fg_tips += " " + m.name
      })

      let inputs = this.checkpointList[this.checkpoint - 1].title

      // 单图四图
      let pic_num = 4;
      if (this.drawingModeNum === 2) {
        //单图
        pic_num = 1
      } else {
        // 四图
        pic_num = 4
      }
      // 同步请求
      this.submitQuestion({
        question: this.navCall === 3 ? this.inputVal + inputs : this.inputVal,
        parameters: parameters,
        img_model: this.clickImgStyleList[this.clickImgStyle.num - 1].desc ? "MJ6.0" : this.img_model,
        is_fast: this.is_fast,
        fg_tips: fg_tips,

        iw_url: this.upload_img_url,
        // iw: this.img_iw,
        iw: this.value1 * 0.025,
        model: 1,
        pic_num: pic_num
      });


    },
    submitQuestion(data, parent_msg_code, i) {
      console.log(1111)
      if (this.sending) {
        this.$message({
          message: '正在任务，不要重复提交，请稍后！',
          type: 'waring'
        });
        return
      }
      this.sending = true;
      // 添加假数据
      let date = new Date(this.currentTimer);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
      * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
      * */
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time_add = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds

      let add = {
        add_time: time_add,
        img_index: 1,
        // img_model: this.img_model,
        // img_type: "img_c",
        img_model: data.img_type=='img_region_variation'?data.img_model:this.img_model,
        img_type: data.img_type=='img_region_variation'?data.img_type:data.isMagc ? "img_video" : "img_c",
        img_url: "",
        is_fast: this.is_fast,
        is_public: 0,
        parameters: "",
        parent_img_type: "",
        progress: 0,
        // prompt: this.inputVal,
        prompt: data.img_type=='img_region_variation'?data.prompt:this.inputVal,
        prompt_en: "",
        status: 1,
      }
      // this.draw_list.unshift(add);
      // this.inputVal = ''
      if (data.img_type != 'img_video') {
        this.draw_list.unshift(add);
        this.scrollToTop();
      }
      // this.scrollToTop();
      // 提交问题
      data.source = "pc";

      this.$http.post('/front/aisd/draw/', data).then((res) => {
        // 获取用户信息
        this.getProfile()
        if (res.status == 200) {
          this.inputVal = "";
          // this.draw_list.splice(0, 1, res.data.draw)
          // // this.draw_list.unshift(res.data.draw);
          // this.scrollToTop();
          // // 发送消息
          // this.checkIds.push(res.data.draw.draw_id)
          if (data.img_type != 'img_video') {
            this.draw_list.splice(0, 1, res.data.draw)
            this.scrollToTop();
            this.checkIds.push(res.data.draw.draw_id)
          } else {
            this.draw_list.unshift(...res.data.draw);
            this.scrollToTop();
            res.data.draw.forEach(mg_id => {
              this.checkIds.push(mg_id.draw_id)
            })
          }

          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {
        }
      }).catch(res => {
        let message = res.message;
        this.draw_list.splice(0, 1)
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满
          this.$confirm(res.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })

      }).finally(() => {
        this.sending = false;
      })
    },
    fetchMsg() {
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/draw/check/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.pic_num = e.pic_num
              item.prompt = e.prompt
              item.prompt_en = e.prompt_en
              item.retry_num = e.retry_num
              item.is_retry = e.is_retry
              item.regenerateload = false
              item.menu_type = e.menu_type
              // item.img_url = e.img_url;
              if (e.status > 2) {
                // 删除生成成功或失败的
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_img_url != "") {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.img_url = e.local_img_url
                item.raw_img_url = e.raw_img_url
                item.single_img_url = e.single_img_url
                item.single_img_url2 = e.single_img_url2
                item.single_img_url3 = e.single_img_url3
                item.single_img_url4 = e.single_img_url4
                this.scrollToTop();
              }
              this.$forceUpdate()
              if (e.status == 3) {
                // 绘画失败
              }
            })
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          clearInterval(this.timer);
        })
      }, 3000)
    },

    imgRedraw(item) {
      // 重新绘画
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_redraw",
        img_index: 1
      }
      this.submitQuestion(data, [], 1);
    },
    drawImgUV(type, i, item, status) {
      // 对图片进行 U V 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      if (status != 0) return
      item[type + '_code'][i] = 2;
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: i + 1,
        pic_num: 1
      }
      this.submitQuestion(data, item[type + '_code'], i);
    },
    drawImgZoom(type, item) {
      // 对图片进行 zoom 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        // img_type: type,
        img_index: 1
      }
      console.log(data)
      // return;
      this.submitQuestion(data, [], 0);
    },
    popClose() {
      this.$refs.viewPopup.close();
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    showDefeatPopup(name) {
      // this.$refs.defeatPopup.show();
      if (name === 'showDefeat') {
        this.$refs.conditionPopup.show();
      } else if (name === 'loraStyle') {
        this.$refs.loraStyle.show();
      } else {
        this.$refs.defeatPopup.show();
      }
    },
    defeatPopClose(name) {

      if (name === 'showDefeat') {
        this.$refs.conditionPopup.close();
      } else if (name === 'loraStyle') {
        this.$refs.loraStyle.close();
      } else {
        this.$refs.defeatPopup.close();
      }
    },
    share_draw_item(item, index) {
      this.current_draw = item
      this.show_sharedraw_popup = true
    },
    recommendCallBack(draw_id) {
      // 推荐到广场 回调
      this.show_recommend_popup = false
      if (draw_id) {
        this.draw_list.forEach(e => {
          if (e.draw_id == draw_id) {
            e.is_public = 1
          }
        })
      }
    },
    pulic_draw_item(item, index) {
      // 点击弹出推荐到广场
      if (item.is_public == 0) {
        this.current_draw = item
        this.show_recommend_popup = true
      } else {
        item.is_public = 0
        this.$http.patch(`/front/aimj/user/draw/${item.draw_id}/`, {
          'action': 'public',
          data: {'sys_cate_id': 0}
        }).then((res) => {
          this.$message({
            message: '取消推荐成功',
            type: 'success'
          });
        }).finally((res) => {
          this.close()
        })
      }

    },
    fave_draw_item(draw, index) {
      // 采集
      this.$refs.drawCateEdit.show(draw, 1)
    },
    //点击弹出反馈弹窗
    handle_show_feedback_popup(item) {
      this.current_draw = item
      this.show_feedback_popup = true
    },
    async getJSON() {
      let url = 'https://mjimg.zhanjuzhe.cn/media/202407/19/1721384316144.png?width=700&height=700';
      try {
        let response = await fetch(url);
        return await response.json();
      } catch (error) {
        console.log('Request Failed', error);
      }
    },
    viewImg(item, type) {
      let img_url = item.raw_img_url
      this.split_img_url = img_url
      const canvas = this.$refs.localCanvas;
      let that = this
      var imgRaw = new Image();
      imgRaw.src = img_url
      imgRaw.setAttribute('crossOrigin', 'anonymous');
      imgRaw.onload = function () {
        var arr = []
        let canvasWidth = imgRaw.width / 2; // Assuming split in half
        let canvasHeight = imgRaw.height / 2; // Adjust as needed
        for (var i = 0; i <= 4; i++) {
          canvas.width = canvasWidth
          canvas.height = canvasHeight

          const ctx = canvas.getContext('2d');
          const x = i % 2 === 0 ? 0 : canvasWidth;
          const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

          ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

          const base64 = canvas.toDataURL('image/jpeg');
          arr.push(base64);
        }

        that.view_img_url = arr[type - 1]
        that.$refs.previewImg.clickHandler();
        that.$nextTick(() => {
          let wrapper = document.getElementsByClassName(
              "el-image-viewer__actions__inner"
          );
          if (wrapper.length > 0) {
            let downImg = document.createElement("i");
            downImg.setAttribute("class", "el-icon-download");
            wrapper[0].appendChild(downImg);
            downImg.addEventListener("click", () => {
              that.$message.success('已为您下载图片，如下载失败，请右键保存或长按保存图片');
              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = that.view_img_url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            });
          }
        })
      }
    },
    caiJiOk(item) {
      // 采集回调
      this.draw_list.forEach(e => {
        if (e.draw_id == item.draw_id) {
          e.cate_id = 8
        }
      })
    },

    clickImage(raw_img_url) {
      // 下载图片
      this.$nextTick(() => {
        let wrapper = document.getElementsByClassName(
            "el-image-viewer__actions__inner"
        );
        let downImg = document.createElement("i");
        downImg.setAttribute("class", "el-icon-download");
        wrapper[0].appendChild(downImg);
        if (wrapper.length > 0) {
          const wrapperElem = wrapper[0];
          downImg.addEventListener("click", () => {
            this.$message.success('已为您下载图片，如下载失败，请右键保存或长按保存图片');
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
              var canvas = document.createElement("canvas");
              canvas.width = image.width;
              canvas.height = image.height;
              var context = canvas.getContext("2d");
              context.drawImage(image, 0, 0, image.width, image.height);
              var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = raw_img_url;
          });
        }
      })
    },
    clickConditionList(item, index, mode) {
      if (mode === 'clear') {
        this.conditionListSelect = []
        this.conditionList.forEach((item) => {
          item.select = false
        })
        return
      }
      if (mode === 'reduce' || mode === 'adds') {
        if (mode === 'reduce') {
          let num1 = Number(this.conditionListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = (num1 - num2).toFixed(1)
          num3 >= 0.1 ? this.conditionListSelect[index].scale = num3 : this.conditionListSelect[index].scale = 0
        } else {
          let num1 = Number(this.conditionListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = Number(num1) + Number(num2)
          num3.toFixed(1) <= 1.9 ? this.conditionListSelect[index].scale = num3.toFixed(1) : this.conditionListSelect[index].scale = 2
        }
        return;
      }
      if (this.conditionList[index].select) {
        this.conditionList[index].select = false
        this.conditionListSelect.forEach((Listitem, Listindex) => {
          if (Listitem.num === item.num) {
            this.conditionListSelect.splice(Listindex, 1)
          }
        })
      } else {
        if (this.conditionListSelect.length <= 1) {
          this.conditionListSelect.push(item)
          this.conditionList[index].select = true
        } else {
          this.$message({
            message: '最多选择两个模型',
            type: 'warning'
          });
        }
      }
    },
    clickLoraStyleList(item, modle) {
      if (modle) {
        this.LoraListStyle.sign = item.sign
        this.LoraListStyle.num = item.num
        this.LoraListStyle.shou = item.shou
        return
      }
      this.clickImgStyle.sign = item.sign
      this.clickImgStyle.num = item.num
      this.clickImgStyle.shou = item.shou

    },
    clickLoraList(item, index, mode) {
      if (mode === 'delete') {
        this.LoraListSelect.splice(item, 1)
        this.clickImgStyleList.forEach((items, indexs) => {
          if (items.num === item.num) {
            this.clickImgStyleList[indexs].select = false
          }
        })
        return
      }
      if (mode === 'reduce' || mode === 'adds') {
        if (mode === 'reduce') {
          let num1 = Number(this.LoraListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = (num1 - num2).toFixed(1)
          num3 >= 0.1 ? this.LoraListSelect[index].scale = num3 : this.LoraListSelect[index].scale = 0
        } else {
          let num1 = Number(this.LoraListSelect[index].scale).toFixed(1)
          let num2 = Number(0.1).toFixed(1)
          let num3 = Number(num1) + Number(num2)
          num3.toFixed(1) <= 0.9 ? this.LoraListSelect[index].scale = num3.toFixed(1) : this.LoraListSelect[index].scale = 1
        }
        return;
      }
      if (mode === 'clear') {
        this.LoraListSelect = []
        this.clickImgStyleList.forEach((item) => {
          item.select = false
        })
        return
      }
      if (this.clickImgStyleList[index].select) {
        this.clickImgStyleList[index].select = false
        this.LoraListSelect.forEach((Listitem, Listindex) => {
          if (Listitem.num === item.num) {
            this.LoraListSelect.splice(Listindex, 1)
          }
        })
      } else {
        if (this.LoraListSelect.length <= 1) {
          this.LoraListSelect.push(item)
          this.clickImgStyleList[index].select = true
        } else {
          this.$message({
            message: '最多选择两个模型',
            type: 'warning'
          });
        }
      }
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      if (res.data.error !== "") {
        this.$message({
          message: res.data.error,
          type: 'error'
        });
        return
      }
      this.imageUrl = res.data.file_full_url;
    },
    beforeAvatarUpload(file) {

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        return
      }
    },
    // 左侧点击
    SdLeftClick(item, name) {
      // 跳转列表
      if (name === 'leftList') {
        this.navCall = item.num
        // 跳转清空
      }
      if (name === 'size') {
        this.imgSizeNum = item.num
        // this.advanceForm.aspect = item.name
      }

      // this.advanceForm.aspect=item.name
    },
    ImageJump(imgurl, s_w, s_h) {
      // window.open(imgurl, '_blank');
      window.open(imgurl, '_blank');
    },
    //下载
    down(item) {
      console.log(item)
      this.$http.get(`/front/aimj/draw/video/${item.draw_id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        } else {
        }
      }).finally(() => {
        this.loading = false
      })

    },
    regenerate(item, ind) {
      console.log(item)
      this.draw_list[ind].regenerateload = true
      this.$forceUpdate()
      this.$http.post(`/front/aimj/draw/retry/`, {id: item.draw_id}).then(res => {
        console.log('res', res)
        if (res.status == '200') {
          this.draw_list[ind].is_retry = 1
          this.draw_list[ind].regenerateload = false
          this.scrollToTop();
          this.$message.success('重新生成创建成功');
          this.draw_list.unshift(res.data);
          this.checkIds.push(res.data.draw_id)
          this.fetchMsg();
        }
      }).catch(err => {
        this.draw_list[ind].regenerateload = false
        this.$forceUpdate()
        console.log('err', err)
        let message = err.message;
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          console.log('列队已满')
          console.log(err.data)
          // 队列已满
          this.$confirm(err.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == "retry_num_max") {
          this.$confirm('已超出最大重试次数', '提示', {
            type: 'warning'
          }).then(() => {
          })
          return;
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })
      })
    },
    // 局部重绘
    openDrowShow(name, item) {
      console.log(name)
      console.log(item)
      this.isDrowShow = true
      // this.partForm.iw_url = item.raw_img_url
      this.partForm.iw_url = item.raw_img_url
      this.partForm.parent_draw_id = item.draw_id
      // this.partForm.prompt = item.prompt
      this.partForm.img_type = 'img_region_variation'
      this.position.x = null
      this.position.y = null
      console.log('position', this.position)
    },
    saveImage(num,) {
      if (num) {
        if(this.partForm.prompt.length<=0){
          this.$message.warning('重绘内容不能为空！')
          return;
        }
        // let this = this
        setTimeout(() => {
          this.canvasLoading = true
          const canvas = this.$refs.canvasDisplay;
          // 获取mask
          canvas.toBlob((blob) => {
            const file = new File([blob], 'my-drawing.png', {type: 'image/png'})
            const formData = new FormData();
            formData.append('file', file,);
            this.$http.post(this.fileApi + '/api/front/upload/?fdir=mj_tool', formData).then(res => {
              // this.$http.post(this.fileApi + '/api/front/upload/?fdir=mj_iw', formData).then(res => {
              // res.data.file_full_url = ''
              if(res.data.file_full_url!=''){
                this.form.iw_url = res.data.file_full_url
                this.isDrowShow = false
                this.clearMaskShow = true
                // 提交局部问题
                this.submitQuestion(this.form)

                // 关闭loading 清除数据
                this.partForm.prompt = ''
                this.position.x=null
                this.position.y=null
                this.Dragging_btn = false
              }else{
                this.$message.error('涂抹区域违规，请修改！')

              }

            }).finally(()=>{
              this.canvasLoading = false

            })
          })
        });
      } else {
        this.clearCanvas()
        this.isDrowShow = false
        this.partForm.iw_url = ''
        this.position.x=null
        this.position.y=null
        this.Dragging_btn = false
      }
    },
    onImageLoad() {
      const img = this.$refs.canvasRecord;
      this.originWidth = img.naturalWidth || img.width
      this.originHeight = img.naturalHeight || img.height
      this.handleResize()
      this.removelDraw()
    },
    removelDraw() {
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');

      const naturalWidth = this.originWidth;
      const naturalHeight = this.originHeight;
      // const maxDimension = 600; // 最大宽高限制
      const maxDimension = this.canvasHeight; // 最大宽高限制
      console.log('this.canvasHeight', this.canvasHeight)
      const canvas2 = this.$refs.canvasDisplay
      this.canvasDisplay = canvas2.getContext('2d');
      this.scale = 1; // 初始缩放比例
      if (naturalWidth > maxDimension || naturalHeight > maxDimension) {
        console.log(11)
        const widthScale = maxDimension / naturalWidth;
        const heightScale = maxDimension / naturalHeight;
        this.scale = Math.min(widthScale, heightScale);
        // scale = Math.max(widthScale, heightScale);
      } else {
        console.log(22)
        this.scale = 1; // 如果图片尺寸小于限制，则保持原始大小
      }
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`

      this.enableDrawing();
      this.brushSize = 30
    },
    // 绘制和清除
    toggleMode(name) {
      this.RemovalMode = name;
      name === 'erase' ? this.opacity = 1 : this.opacity = 10
    },
    enableDrawing() {
      // let this = this
      let isDrawing = false;
      const canvas2 = this.$refs.canvasDisplay;
      this.canvasDisplay = canvas2.getContext('2d');
      // 将整个画布填充为黑色
      // this.canvasDisplay.fillStyle = "black";
      // this.canvasDisplay.fillRect(0, 0, canvas2.width, canvas2.height);
      // 鼠标画板按下
      canvas2.addEventListener('mousedown', (e) => {
        isDrawing = true;
        this.canvasDisplay.beginPath();
        this.canvasDisplay.moveTo(e.offsetX, e.offsetY);
        console.log(e.offsetX, e.offsetY);
      });
      // 鼠标画板移动
      canvas2.addEventListener('mousemove', (e) => {

        if (isDrawing == true && this.RemovalMode !== 'erase' && (!this.isDragging || !this.Dragging_btn)) {

          this.drawnPath.push({x: e.offsetX, y: e.offsetY})
          this.drawCircle(this.canvasDisplay, e.offsetX, e.offsetY, 'rgb(255,255,255)');
        }
        if (this.RemovalMode == 'erase' && isDrawing) {
          let qingx = e.offsetX
          let qingy = e.offsetY
          this.clearPath.push({x: e.offsetX, y: e.offsetY})
          this.erase(this.canvasDisplay, qingx, qingy)
        }
      });
      // 鼠标画板松开
      canvas2.addEventListener('mouseup', () => {
        isDrawing = false;
      });
      // 鼠标画板离开
      canvas2.addEventListener('mouseout', () => {
        isDrawing = false;
      });
    },
    clearCanvas() {
      // 清除整个画布
      const canvas = this.$refs.canvasRecord;
      const canvas2 = this.$refs.canvasDisplay;
      this.canvasDisplay.clearRect(0, 0, canvas.width, canvas.height);
      this.drawnPath = []
      this.removelDraw()
      this.RemovalMode = 'draw'
    },
    erase(ctx, x, y, w, h) {
      console.log('清除笔刷')
      const brushSize = this.brushSize;
      ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
      ctx.beginPath();
      ctx.arc(x, y, brushSize, 0, Math.PI * 2); // 绘制一个圆形
      ctx.fill(); // 填充圆形，实现擦拭效果
      this.clearRea(x, y)
      // ctx.globalCompositeOperation = 'source-over'; // 恢复默认模式
      if (w && h) {
        const largeWidth = w;
        const largeHeight = h;
        const smallWidth = this.$refs.originImg.width;
        const smallHeight = this.$refs.originImg.height;

        // 计算缩放比例
        const scaleX = smallWidth / largeWidth;
        const scaleY = smallHeight / largeHeight;
        const brushSize = this.brushSize;
        ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
        ctx.beginPath();
        ctx.arc(x, y * scaleY + this.changeNum, brushSize, 0, Math.PI * 2); // 绘制一个圆形
        ctx.fill(); // 填充圆形，实现擦拭效果
        // this.clearRea(x,y)
      }
    },
    clearRea(x, y) {
      let r = this.brushSize
      this.drawnPath.forEach((item, index) => {
        if ((item.x >= x - r && item.x <= x + r) && (item.y >= y - r && item.y <= y + r)) {
          this.drawnPath.splice(index, 1)
        }
      })
    },
    drawCircle(ctx, x, y, col = 'rgba(0, 255, 0, 0.5)', w, h) {
      console.log('涂写')
      ctx.globalCompositeOperation = 'source-over'
      this.canvasDisplay.beginPath();
      this.canvasDisplay.arc(x, y, this.brushSize, 0, Math.PI * 2); // 绘制一个半径为 10 的圆形
      this.canvasDisplay.fillStyle = col; // 绿色半透明
      this.canvasDisplay.fill();
      this.canvasDisplay.closePath();
    },
    updateScale(data) {
      const maxScale = 3; // 最大缩放比例
      const minScale = 0.2; // 最小缩放比例
      if (data) {//放大
        if (this.scale < maxScale) {
          this.scale += 0.2; // 每次缩放的增量
          if (this.scale >= 3) {
            this.scale = 3
          }
        }
      } else {//缩小\
        if (this.scale > minScale) {
          this.scale -= 0.2; // 最小缩放比例
        }
      }
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`
    },
    startDrag(e) {
      console.log('startDrag')
      // 拖动
      this.isDragging = true
      this.Dragging_num = 0
      document.addEventListener('mousemove', this.drag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    stopDrag() {
      // 拖动
      this.isDragging = false
      this.Dragging_num = 0
      document.removeEventListener('mousemove', this.drag)
    },
    drag(e) {
      // 拖动
      if (!this.isDragging || !this.Dragging_btn) return
      // 获取拖动次数
      this.Dragging_num++
      const element = this.$refs.canvasRecord;

      this.position.x = element.offsetLeft
      this.position.y = element.offsetTop
      this.position.x = this.position.x + e.movementX
      this.position.y = this.position.y + e.movementY
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mg_video_box {
  // height: 400px;
  .mg_video_item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    // .videoBox::-webkit-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-moz-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-ms-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-o-media-controls {
    //   display: none !important;
    // }
    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(19, 18, 18, 0.6);
      color: white;
      font-size: 24px;
      border: none;
      border-radius: 50%;
      // padding: 12px 20px;
      cursor: pointer;
      z-index: 10;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    video {
      max-width: 100%; /* 限制宽度不超过容器宽度 */
      max-height: 100%; /* 限制高度不超过容器高度 */
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 可选，阴影效果 */
      border-radius: 8px; /* 可选，圆角效果 */
    }
  }
}

.mgTitp {
  display: inline-block;
  padding: 0 7px;
  background: linear-gradient(to right, rgb(99, 231, 82), rgb(98, 238, 247));
  border-radius: 4px;
  font-size: 12px;
  line-height: 24px;
  color: #000;
  margin-right: 10px;
}

@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

.btm_area_con {
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 25px;
  border: 2px solid #5865f2;
  border-radius: 8px;
  background-color: #37393f;
  padding: 10px 15px;

  .begin_draw_tips {
    position: absolute;
    top: -60px;
    left: 10%;
    animation: scale-breathe 2s infinite linear;
  }

  .text_area {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #46474b;
    position: relative;

    .textarea {
      flex: 1;
      margin-right: 20px;
      height: 42px;
      line-height: 21px;
      font-size: 14px;
      color: #fff;
      border: none;
      background: transparent;
    }

    .submit {
      background: #5865f2;
      border-radius: 6px;
      padding: 7px 14px;
      cursor: pointer;

      /deep/ .el-loading-mask {
        background: none;
      }

      img {
        width: 14px;
        height: 14px;
      }

      span {
        font-size: 14px;
        color: #fff;
        margin-right: 5px;
      }

      &:hover {
        background-color: rgba(88, 101, 242, 0.867);
      }
    }
  }

  .query_area {
    .query_area_item {
      .query_select {
        width: 89px;
        font-size: 12px;

        /deep/ .el-input__inner {
          border: 0;
          font-size: 12px;
          padding: 0;
          height: 28px;
          line-height: 28px;
          color: #6d6f78;
          background: #17181a url("./img/icon_img34.png") no-repeat 10px center;
          background-size: 14px 14px;
          padding-left: 30px;
        }

        /deep/ .el-input__suffix {
          display: none;
        }
      }
    }

    .query_area_btn {
      height: 28px;
      border-radius: 4px;
      background-color: #17181a;
      padding: 0 9px;
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      span {
        font-size: 13px;
        color: #6d6f78;
      }

      &:hover {
        background: #212121;
      }
    }

    .spell {
      font-size: 13px;
      margin-left: 7px;
    }
  }

  .mode_hover {
    position: absolute;
    bottom: 53px;
    left: 5px;
    background-color: #17181a;
    padding: 5px 0;
    border-radius: 6px;

    &:before {
      position: absolute;
      content: " ";
      left: 50%;
      bottom: -8px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      border-top: 8px solid #17181a;
    }

    .mode_hover_item {
      padding: 10px 16px;
      cursor: pointer;

      span {
        font-size: 13px;
        color: #b5bac1;
      }

      img {
        width: 14px;
        height: 14px;
        margin-left: 10px;
      }

      &:hover {
        background-color: #2a2a2a;
        color: #fff;
      }
    }
  }

  .search_tips {
    background-color: #1e1f22;
    position: absolute;
    width: 100%;
    top: -10px;
    left: 0;
    transform: translateY(-100%);
    border-radius: 6px;
    padding: 15px 15px 25px 15px;
    color: #b5bac1;

    .title {
      padding-bottom: 6px;

      p {
        font-size: 16px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }

        span {
          font-size: 20px;
          font-weight: bold;
          color: #f90;
        }
      }

      .close {
        width: 20px;
        height: 20px;
        cursor: pointer;
        opacity: 0.4;

        &:hover {
          opacity: 1;
        }
      }
    }

    .tips_list {
      height: 500px;
      overflow-y: auto;

      .tips_list_item {
        padding: 12px 6px;
        border-radius: 3px;
        cursor: pointer;

        .tips_list_item_avatar {
          width: 35px;
          height: 35px;
          margin-right: 15px;
          border-radius: 100%;
        }

        .text {
          flex: 1;

          p {
            font-size: 14px;
            color: #b5bac1;
            line-height: 1;
          }

          .zh {
            margin-bottom: 7px;
          }
        }

        &:hover {
          background-color: #2b2d31;
        }
      }
    }
  }
}

.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.left_area {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .createButton {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid #36373d;

    div {
      font-size: 16px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;

      span {
        font-size: 12px;
      }
    }
  }

  .left_top {
    padding: 10px;
    height: calc(100% - 76px);
    //overflow-y: auto;
  }

  .left_nav {
    padding: 4px 0;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #36373d;
    display: flex;
    align-items: center;

    color: #fff;

    div {
      flex: 1;
      text-align: center;
      margin: 0 4px;
      cursor: pointer;
    }

    .navSelected {
      background-color: #5865f2;
      border-radius: 4px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .scrollable-content {
    overflow-y: auto;
    height: calc(100% - 50px);
    margin: 10px 0;
    color: #fff;
    padding: 0 5px 0 0;

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;

      .left {
        margin-right: 12px;
        width: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        flex: 1;


        div {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          line-height: 20px;
        }

      }
    }

    .describe {
      .refer_title {
        height: 18px;
        margin: 15px 0;
        display: flex;
        align-items: center;
        font-size: 14px;

        div {
          height: 100%;
          border: 2px solid #5865f2;
          border-radius: 2px;
          margin-right: 5px;
        }
      }

      .refer_depict {
        border-radius: 5px;
        border: 2px solid #5865f2;
        padding: 10px 10px;

        .text {
          width: 100%;
          background-color: #2b2d31;
          border: 0;
          color: #b4b9bf;
          font-size: 14px;
          letter-spacing: 1.5px;
          line-height: 20px;
        }

        .depict_switch {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          margin-top: 10px;

          .switch {
            display: flex;
            align-items: center;

            span {
              margin-left: 10px;
            }
          }

          .empty {
            color: #b4b9bf;
            cursor: pointer;
          }

          .empty:hover {
            color: #fff;
          }
        }
      }

      .toolsModelList {

        //scrollbar-width: thin;
        .music_style {
          overflow-x: auto;
          width: 100%;
          white-space: nowrap;
          padding: 0 0 5px 0;

          span {
            font-size: 14px;
            margin-right: 15px;
            cursor: pointer;

          }

          .spanColor {
            color: #5865f2;
          }
        }

        .music_styleImg {
          padding: 0 0 0 0;
          display: flex;
          flex-wrap: wrap;

          //height: 270px;
          overflow: hidden;
          gap: 5px 10px;

          .styleImg_item {
            width: 83px;
            height: 83px;
            position: relative;
            border: 2px solid #5865f200;
            border-radius: 5px;
            overflow: hidden;
            margin: 2px 0;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;

            }

          }

          .item_click {
            border: 2px solid #5865f2;
            width: 83px;
            height: 83px;
            position: relative;
            border-radius: 5px;
            margin: 2px 0;
            cursor: pointer;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }

        .upDown {
          background-color: #1e1f22;
          padding: 5px 0;
          display: flex;
          cursor: pointer;

          img {
            margin: 0 auto;
          }
        }

      }

      .img_size {
        display: flex;
        flex-wrap: wrap;
        //justify-content: space-between;
        gap: 10px;

        .imgSize_item {
          width: 83px;
          height: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: #1d2027;
          border-radius: 3px;
          border: 2px solid #393c43;
          margin-bottom: 10px;
          color: #8E9093;
          cursor: pointer;

          .item_img {
            img {
              height: 40px;
            }
          }

          .item_name {
            margin: 2px 0;
          }

          .item_title {

          }

        }

        .ClickImgSize_item {
          width: 83px;
          height: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: #32354e;
          border-radius: 3px;
          border: 2px solid #5865f2;
          margin-bottom: 10px;
          color: #8E9093;
          cursor: pointer;

          .item_img {
            img {
              height: 40px;
            }
          }

          .item_name {
            margin: 2px 0;
          }

          .item_title {

          }

        }


      }

      .drawingMode {
        display: flex;
        justify-content: space-between;

        .itemMode {
          padding: 10px 35px;
          background-color: #1d2027;
          border-radius: 3px;
          border: 2px solid #5865f200;
          cursor: pointer;
          position: relative;

          .vip {
            position: absolute;
            color: #f0b132;
            font-size: 14px;
            font-weight: 700;
            top: -11px;
            right: 0;
          }
        }

        .mode {
          padding: 10px 35px;
          background-color: #1d2027;
          border-radius: 3px;
          border: 2px solid #5865f2;
          cursor: pointer;
          position: relative;

          .vip {
            position: absolute;
            color: #f0b132;
            font-size: 14px;
            font-weight: 700;
            top: -11px;
            right: 0;
          }
        }
      }

      .picture_sel {
        background-color: #1e1f22;
        padding: 16px 14px;
        border-radius: 5px;

        .picture_top {
          display: flex;

          .upload_img {
            width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px dashed #cedffe80;
            border-radius: 5px;
            overflow: hidden;

            .noUpload {
              color: #c0c4cc;

              .el-icon-plus {
                font-size: 30px;
                font-weight: 700;
              }

              .noUpload_text {
                font-size: 14px;
              }
            }

            .hoverImg {
              display: none;
            }

            //.hoverImg{
            //   width: 100px;
            //   height: 100px;
            //   background-color: #67676982;
            //   font-size: 16px;
            //   line-height: 100px;
            //   text-align: center;
            //   display: block;
            //  color: white;
            // }

          }

          .upload_img:hover {
            .hoverImg {
              width: 100px;
              height: 100px;
              background-color: #67676982;
              font-size: 16px;
              line-height: 100px;
              text-align: center;
              display: block;
              color: white;
            }
          }


          .style_strength {
            flex: 1;
            padding: 0 0 0 10px;
            font-size: 14px;
            color: #b4b9bf;

            .strength_top {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
            }

            .strength_bot {
              /deep/ .el-slider__bar {
                height: 6px;
                background-color: #5865f2;
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;
                position: absolute;
              }

              /deep/ .el-slider__button {
                border: 2px solid #5865f2;
              }

            }
          }

        }

        .picture_bot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 16px;

          .one {
            font-size: 13px;
            margin-bottom: 5px;
          }

          .two {
            font-size: 12px;
            color: #b4b9bf;
          }

          .three {
            font-size: 14px;
            color: #b4b9bf;
            display: flex;
            align-items: center;

            span {
              margin-right: 5px;
            }
          }
        }

      }

      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 269px;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }

      .ControlNet {
        height: 80px;
        background-color: #1d2027;
        border-radius: 5px;
        font-size: 14px;
        color: #aaaaaa;

        .ControlNet_one {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .ControlNet_two {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .left {

            .conditionSelect {
              width: 200px;
              height: 25px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background-color: #36373d;
              padding: 0 10px;
              border-radius: 3px;
              margin: 5px 0;

              .reduce {
                font-size: 20px;
                cursor: pointer;
              }

              .add {
                font-size: 20px;
                cursor: pointer;
              }

              .title {
                font-size: 13px;
              }
            }
          }

          .right {
            margin: 0 0 0 5px;
          }

        }

      }

      .checkpoint {
        display: flex;
        justify-content: space-between;
        white-space: nowrap;

        .checkpoint_item {
          width: 48px;
          height: 65px;
          position: relative;
          border-radius: 5px;
          overflow: hidden;
          border: 2px solid #00000000;
          cursor: pointer;

          img {
            object-fit: cover;
            height: 65px;
            //overflow-clip-margin: content-box;
            //overflow: clip;
          }

          div {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #000000ba;
            font-size: 12px;
            text-align: center;
            padding: 5px 0;
          }
        }

        .checkpoint_items {
          width: 48px;
          height: 65px;
          position: relative;
          border-radius: 5px;
          overflow: hidden;
          border: 2px solid #5865f2;
          cursor: pointer;

          img {
            //width: 45px;
            height: 65px;
            object-fit: cover;
          }

          div {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #000000ba;
            font-size: 12px;
            text-align: center;
            padding: 5px 0;
          }
        }

      }

      .fusionStyle {
        .fusionStyle_one {
          //height: 54px;
          width: 100%;
          border: 1px solid #393d45;
          border-radius: 6px;
          background-color: #1d2027;
          padding: 10px 10px;
          font-size: 12px;
          color: #abb0b6;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          .fusionStyle_oneLeft {
            padding: 10px 10px;
            border: 1px dashed #393d45;
            border-radius: 6px;
          }

          .fusionStyle_oneLeft:hover {
            color: #cccccc;
          }

          .fusionStyle_oneRight {
            span {
              font-size: 14px;
              color: #cccccc;
            }

            div {
              margin: 5px 0 0 0;
            }
          }
        }

        .fusionStyle_two {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .two_Imgs {
            width: 130px;
            height: 100px;
            background-color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            border-radius: 8px;

            .two_Img {
              width: 130px;
              height: 70px;
              white-space: nowrap;
              position: relative;

              img {
                width: 100%;
                height: 70px;
                object-fit: cover;
              }

              .closes {
                position: absolute;
                top: 0;
                right: 0;
                width: 25px;
                height: 25px;
                border-bottom-left-radius: 6px;
                background-color: #0000007a;
                cursor: pointer;
                padding: 0 5px;
                // 穿透更改图标大小
                /deep/ i.el-icon-error {
                  font-size: 16px;
                  color: #b4afb0;
                  line-height: 25px;

                }

                /deep/ i.el-icon-error:hover {
                  font-size: 16px;
                  color: #ffffff;
                }
              }

              .title {
                width: 100%;
                font-size: 12px;
                background-color: #000000ba;
                text-align: center;
                padding: 5px 0;
                position: absolute;
                bottom: 0;
                left: 0;
              }
            }

            .two_bot {
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              height: 30px;

              div:nth-child(1) {
                font-size: 20px;
                font-weight: 700;
                cursor: pointer;
              }

              div:nth-child(3) {
                font-size: 20px;
                font-weight: 700;
                cursor: pointer;
              }
            }
          }

        }
      }

      .parameter {
        width: 100%;
        padding: 15px 15px;
        border-radius: 6px;
        background-color: #1d2027;
        font-size: 14px;

        .parameter_title {
          margin: 0 0 5px 0;
        }

        .parameter_slider {
          border-bottom: 1px solid #282B31;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 0 10px 0;
          margin: 0 0 10px 0;

          .slider_num {
            width: 40px;
            height: 28px;
            background-color: #2d313b;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          .slider {
            flex: 1;
            margin: 0 0 0 10px;

            /deep/ .el-slider__bar {
              background-color: #5865f2;
            }

            /deep/ .el-slider__button {
              border-color: #FFF;
              cursor: grab;
            }
          }
        }

        .Negative_Prom {
          .Negative_text {
            width: 100%;
            height: 50px;
            background-color: #313338;
            border: 2px solid #393c43;
            color: #c7d2c9;
            padding: 5px 5px;
            font-size: 14px;
            border-radius: 4px;
          }

          textarea::placeholder {
            color: #a8abb2; /* 将颜色改为灰色 */
          }

        }
      }

      .music_style::-webkit-scrollbar {
        height: 5px !important;
      }

    }
  }

  .logo_area {
    flex-direction: column;
    //width: 216px;
    height: 216px;
    background: #1e1f22;
    border-radius: 10px;
    margin: 12px;

    img {
      width: 64px;
      height: 64px;
      border-radius: 100%;
    }

    .title {
      font-size: 14px;
      color: #fff;
      margin: 10px 0;

      span {
        padding: 2px 8px;
        border-radius: 3px;
        background: #23a559;
        margin-left: 5px;
        font-size: 12px;
      }
    }

    .desc {
      font-size: 12px;
      color: #7d8289;
      padding: 0 10px;
      text-align: center;
    }
  }

  .model_list {
    font-size: 12px;
    font-weight: bold;
    color: #949ba4;
    padding: 0 8px;
    flex: 1 1 0%;

    .title {
      img {
        margin-right: 5px;
      }
    }

    .item {
      margin-top: 10px;
      padding: 8px 12px;
      border-radius: 2px;
      cursor: pointer;
      position: relative;

      span {
        color: #949ba4;
        margin-right: 10px;
      }

      .desc {
        strong {
          font-size: 13px;
          color: #fff;
          line-height: 1;

          img {
            width: 36px;
            height: 12px;
            margin-left: 5px;
          }
        }

        p {
          font-size: 12px;
          color: #949ba4;
          word-break: break-all;
          white-space: normal;
        }
      }

      &:hover,
      &.active {
        background-color: #305543;
        background: -o-linear-gradient(left, #305543 0%, #3d437e 100%);
        background: -ms-linear-gradient(left, #305543 0%, #3d437e 100%);
        background: linear-gradient(left, #305543 0%, #3d437e 100%);
        background: -moz-linear-gradient(
                left,
                #305543 0%,
                #3d437e 100%
        );
        background: -webkit-linear-gradient(
                left,
                #305543 0%,
                #3d437e 100%
        );
      }

      &.active {
        &:after {
          content: "";
          position: absolute;
          width: 14px;
          height: 10px;
          background: url("./img/icon_img5.png") no-repeat center;
          background-size: cover;
          right: 10px;
          top: calc(50% - 5px);
        }
      }
    }
  }

  .person {
    padding: 8px 16px;
    background: #232428;
    position: relative;

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 7px;
      cursor: pointer;
    }

    .info {
      width: 150px;
      cursor: pointer;

      .name {
        font-size: 13px;
        color: #fff;
        margin-bottom: 5px;

        img {
          width: 20px;
          height: 20px;
          // filter: grayscale(100%);
        }
      }

      .id {
        font-size: 12px;
        color: #b5bac1;
      }
    }

    .icon_person {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    .person_hover {
      background: #111214;
      border-radius: 8px;
      padding: 18px 16px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
      width: 308px;
      z-index: 99;
      animation: fade-in 0.3s ease-in forwards;

      .user_avatar {
        position: relative;
        z-index: 2;
        padding: 20px 10px 0;

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 60px;
          background: #5865f2;
          z-index: -1;
          border-radius: 6px 6px 0 0;
        }

        .pic {
          width: 80px;
          height: 80px;
        }

        .edit_area {
          display: block;
          width: 20px;
          height: 20px;
          padding: 4px;
          border-radius: 100%;
          background-color: rgba(0, 0, 0, 0.24);
          cursor: pointer;

          img {
            width: 12px;
            height: 12px;
          }
        }
      }

      .item {
        padding: 14px 0;
        margin: 0 20px;
        border-bottom: 1px solid #2e2f34;
        color: #b4b9bf;
      }

      .user {
        .name {
          font-size: 16px;
          color: #fff;
          margin-bottom: 5px;

          img {
            width: 20px;
            height: 20px;
            // filter: grayscale(100%);
          }
        }

        .id {
          font-size: 12px;
          color: #b5bac1;
        }
      }

      .open {
        .open_desc {
          color: #000;
          color: #68d1bf;
          margin-top: 5px;
        }
      }

      .point {
        .flex {
          margin-top: 5px;
          color: #68d1bf;
          font-weight: bold;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }

      .logout {
        border-bottom: none;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;

        .logout_desc {
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }

        .icon_right {
          width: 7px;
          height: 10px;
        }
      }
    }
  }
}

.draw_area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #313338;

  .draw_area_tips {
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid #26282c;
    display: flex;
    align-items: center;

    .one {
      font-size: 18px;
      color: #949ba4;
    }

    .two {
      font-size: 16px;
      color: #fff;
      margin: 0 10px;
    }

    .three {
      font-size: 12px;
      color: #f0b132;
    }
  }

  .draw_scroll {
    padding-top: 10px;

    flex: 1;
    position: relative;
    z-index: 9;
    overflow-y: auto;

    .draw_list {
      padding-right: 12px;
      position: relative;
      z-index: 2;

      .draw_list_item {
        padding: 16px;
        background: rgba(152, 121, 69, 0.13);
        border-left: 2px solid #f0b132;
        border-radius: 2px;
        margin-bottom: 15px;

        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 100%;
          margin-right: 20px;
        }

        .text {
          flex: 1;

          .title {
            .info {
              .name {
                font-size: 16px;
                color: #fff;
              }

              .tag {
                line-height: 24px;
                background-color: #5865f280;
                color: #fff;
                font-size: 12px;
                padding: 0 7px;
                border-radius: 4px;
                margin: 0 10px;
              }

              .time {
                color: #707070;
              }
            }

            .delete {
              cursor: pointer;
              margin-left: 8px;

              img {
                width: 20px;
                height: 20px;
                opacity: 0.5;
                margin-right: 3px;

                &.share {
                  width: 16px;
                  height: 16px;
                }
              }

              &:hover {
                color: #fff;

                img {
                  opacity: 1;
                }
              }
            }
          }

          .desc {
            margin: 10px 0;

            p {
              font-size: 14px;
              color: #fff;
              //display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 3;
              padding: 10px 0;
              word-break: break-all;
            }

            .en {
              color: #999168;
              border-top: 1px solid #555041;
            }
          }
        }

        .big_img {
          img {
            max-height: 400px;
          }
        }

        .options {
          .options_list {
            margin-top: 10px;

            p {
              font-size: 14px;
              color: #fff;
            }

            .tips_icon {
              width: 18px;
              height: 18px;
              opacity: 0.5;
            }

            span {
              font-size: 13px;
              width: 58px;
              height: 32px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              background: #4e5058;
              margin-left: 8px;
              border-radius: 3px;
              cursor: pointer;

              img {
                width: 18px;
                height: 18px;
              }

              &:hover {
                background: #6e717c;
              }

              &.span {
                width: 100px;

                img {
                  margin-right: 5px;
                }
              }

              &.span2 {
                width: 40px;
              }
            }

            //
            .redraw {
              img {
                height: 20px;
                // margin-top: 5px;
              }

              line-height: 32px;
            }

            .btn {
              // flex-grow: 1;
              // height: 32px;
              // line-height: 32px;
              // color: #18a058;
              // background-color: #dbefe4;
              // border-radius: 2px;
              // font-size: 12px;
              // font-weight: bold;
              // text-align: center;
              // cursor: pointer;
              // width: 0;
              &:not(:last-child) {
                margin-right: 0px;
              }

              &.loading {
                opacity: 0.6;

                svg {
                  margin-top: -4px;
                  vertical-align: middle;
                  margin-right: 4px;
                  animation: rotate 2s linear infinite;
                }
              }

              &.redraw2 {
                background-color: #f5f6fb;

                img {
                  height: 30px;
                }
              }

              &.disabled {
                cursor: not-allowed;
                background-color: #ddd;
                color: #666;
              }
            }

            //
          }
        }
      }
    }
  }

  .btm_area {
    padding: 0 16px;
    height: 85px;
    border-top: 1px solid #26282c;
    position: relative;
    z-index: 19;
  }
}

.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}

.userinfo_popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;
}

.centerPanel {
  position: fixed;
  z-index: 1501;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.2s;
}

.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .alert_title {
      p {
        font-size: 14px;
        color: #fff;
      }

      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}

.userphone_con {
  width: 440px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .alert_title {
      justify-content: end;

      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .desc {
      text-align: center;
      font-size: 14px;

      .c-fff {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }

    .form {
      padding: 0 30px 50px;

      .input {
        border: 2px solid #36373d;
        background: #2b2d31;
        padding: 9px 12px;
        border-radius: 8px;
        margin-top: 25px;

        input {
          height: 30px;
          line-height: 30px;
          flex: 1;
          border: 0;
          background: transparent;
          color: #fff;
          font-size: 14px;
        }

        span {
          cursor: pointer;
          margin-left: 20px;
          color: #5865f2;

          &:hover {
            color: #5865f2cc;
          }
        }
      }
    }

    .submit {
      margin: 0 30px 50px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 6px;
      line-height: 53px;
      text-align: center;
      font-size: 16px;

      &:hover {
        background-color: rgba(88, 101, 242, 0.867);
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 190px;
  //height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding: 14px 10px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    //line-height: 64px;
    margin: 10px 0 36px;
  }

  .error_text2, .error_text3 {
    font-size: 12px;
    color: #56b15b;
  }

  .error_text2 {
    cursor: pointer;
    margin-bottom: 5px;
  }

  .error_text3 {
    color: #ccc;
    margin-bottom: 36px;
  }

  .error_text4 {
    font-size: 12px;
    color: #ccc;
    line-height: 1.8;

    a {
      color: red;
    }
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.create_error_old {
  width: 190px;
  // height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    //line-height: 64px;
    margin: 10px 0 0px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding: 30px 0;
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.condition_Popup {
  width: 555px;
  //height: 560px;
  background-color: #000000;
  border: 2px solid #5865f2;
  color: #d6d6d6;
  padding: 20px;
  border-radius: 5px;

  .conditionTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 15px;
    font-weight: 700;

    .clear {
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-error {
        font-size: 20px;
        color: #565658;
      }
    }

    .clear:hover {
      background-color: #343538;
    }
  }

  .conditionTips {
    color: #d6d6d6;
    font-size: 13px;
    margin: 10px 0;
  }

  .conditionShow {
    display: flex;
    justify-content: space-between;
    margin: 0 0 10px 0;

    .conditionSelect {
      width: 245px;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #1a1a1a;
      padding: 0 10px;
      border-radius: 3px;

      .reduce {
        font-size: 20px;
        cursor: pointer;
      }

      .add {
        font-size: 20px;
        cursor: pointer;
      }

      .title {
        font-size: 13px;
      }
    }
  }

  .condition_List {
    height: 410px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .List_itme {
      width: 160px;
      height: 140px;
      border: 2px solid #5865f200;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      background-color: #373737;

      .item_img {
        width: 100%;
      }

      .title {
        padding: 1px 8px;

        div {
          font-size: 13px;
          color: #FFFFFF;
        }

        span {
          font-size: 12px;
          color: #AAAAAA;
        }
      }
    }

    .List_itmes {
      border: 2px solid #5865f2;
      width: 160px;
      height: 140px;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      background-color: #373737;

      .item_img {
        width: 100%;
      }

      .title {
        padding: 1px 8px;

        div {
          font-size: 13px;
          color: #FFFFFF;
        }

        span {
          font-size: 12px;
          color: #AAAAAA;
        }
      }
    }
  }

  .conditionBtn {
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    cursor: pointer;

    div {
      width: 100px;
      height: 30px;
      margin: 0 10px;
      border-radius: 15px;
      text-align: center;
      line-height: 30px;
      font-size: 13px;
    }

    div:nth-child(1) {
      background-color: #3c434a;
      color: #FFFFFF90;
    }

    div:nth-child(2) {
      background-color: #5865f2;
      color: #FFF;
    }
  }
}

.loraStyle_Popup {
  width: 450px;
  background-color: #000000;
  border: 2px solid #5865f2;
  color: #d6d6d6;
  padding: 20px;
  border-radius: 5px;

  .conditionTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 15px;
    font-weight: 700;

    .clear {
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-error {
        font-size: 20px;
        color: #565658;
      }
    }

    .clear:hover {
      background-color: #343538;
    }


  }

  .conditionTips {
    color: #d6d6d6;
    font-size: 13px;
    margin: 10px 0;
  }

  .conditionShow {
    display: flex;
    justify-content: space-between;
    margin: 0 0 10px 0;

    .conditionSelect {
      width: 200px;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #1a1a1a;
      padding: 0 10px;
      border-radius: 3px;

      .reduce {
        font-size: 20px;
        cursor: pointer;
      }

      .add {
        font-size: 20px;
        cursor: pointer;
      }

      .title {
        font-size: 13px;
      }
    }
  }

  .music_style {
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    padding: 0 0 5px 0;

    span {
      font-size: 14px;
      margin-right: 15px;
      cursor: pointer;

    }

    .spanColor {
      color: #5865f2;
    }
  }

  .condition_List {
    height: 410px;
    overflow-y: auto;


    .music_styleImg {
      padding: 0 0 0 0;
      display: flex;
      flex-wrap: wrap;

      //height: 270px;
      overflow: hidden;
      gap: 5px 10px;

      .styleImg_item {
        width: 90px;
        height: 90px;
        position: relative;
        border: 2px solid #5865f200;
        border-radius: 5px;
        overflow: hidden;
        margin: 2px 0;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }

        div {
          width: 100%;
          padding: 2px 0;
          text-align: center;
          font-size: 12px;
          background-color: #000000ac;
          position: absolute;
          left: 0;
          bottom: 0;

        }

      }

      .item_click {
        border: 2px solid #5865f2;
        width: 91px;
        height: 91px;
        position: relative;
        border-radius: 5px;
        margin: 2px 0;
        cursor: pointer;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        div {
          width: 100%;
          padding: 2px 0;
          text-align: center;
          font-size: 12px;
          background-color: #000000ac;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }

    .upDown {
      background-color: #1e1f22;
      padding: 5px 0;
      display: flex;
      cursor: pointer;

      img {
        margin: 0 auto;
      }
    }

  }

  .conditionBtn {
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    cursor: pointer;

    div {
      width: 100px;
      height: 30px;
      margin: 0 10px;
      border-radius: 15px;
      text-align: center;
      line-height: 30px;
      font-size: 13px;
    }

    div:nth-child(1) {
      background-color: #3c434a;
      color: #FFFFFF90;
    }

    div:nth-child(2) {
      background-color: #5865f2;
      color: #FFF;
    }
  }
}

.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0px;
    right: 0px;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("./img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  max-width: 400px;
  position: relative;
  overflow: hidden;
  position: relative;
  // border-radius:5px;
  .look_img {
    display: none;
    //opacity: 0;
    cursor: pointer;
    width: 100px;
    height: 36px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 32px;
    text-align: center;
  }

  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("./img/download.png");
        }

        &.preview {
          background-image: url("./img/preview_img.png");
        }

        &.delete {
          background-image: url("./img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  // 图片上传
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    padding: 5px 5px;

  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
    width: 100px !important;
    height: 100px !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    text-align: center;
  }

  .avatars {
    width: 100px;
    height: 100px;
    display: block;
    border: 1px dashed #d9d9d9;
  }


  // 图片上传
}

.music_style::-webkit-scrollbar {
  height: 5px !important;
}

.msg_img_wrap:hover {
  .look_img {
    display: block;
  }
}
.drowPopB {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  //width: 100vw;
  //height: 100vh;
  .imgRemovalPopup {
    //margin-top: 40px;
    padding: 20px 15px;
    background-color: rgb(30, 31, 34);
    border-radius: 10px;
    font-size: 14px;
    color: #fafafa;

    width: 95vw;
    height: 95vh;
    box-sizing: border-box;

    .imgbox_top {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 700;
    }

    .imgbox_center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;

      .apply {
        display: flex;

        span {
          display: block;
          width: 100px;
          padding: 8px 0;
          text-align: center;
          background-color: #31374a;
          border-radius: 5px;
          border: 2px solid #31374a;
          cursor: pointer;
        }

        .spancol {
          border: 2px solid #04c066;
        }
      }

      .brush {
        display: flex;
        align-items: center;
        position: relative;
        margin-right: 30px;

        .addBtn {
          width: 22px;
          //height: 20px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .slider {
          width: 100px;
          margin: 0 10px;
        }
      }

      .scoBox {
        display: flex;
        justify-content: space-between;
        width: 130px;
      }

      .scoleBox {
        display: flex;
        align-items: center;

        .scoText {
          margin-right: 10px;
        }

        .scoBtn {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #fff;
          background: #919090;
          cursor: pointer;
          margin-right: 10px;
        }
      }

      .clear_btn {
        div {
          padding: 8px 20px;
          margin: 0 20px 0 0;
          text-align: center;
          background-color: #31374a;
          border-radius: 5px;
          border: 2px solid #31374a;
          cursor: pointer;
        }
      }

    }

    .canvas_region {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      background: rgb(20, 24, 36);
      position: relative;
      width: 100%;
      height: calc(100vh - 250px);

      .canvas-wrapper {
        position: relative;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0 !important;
      }

      #imageOrigin {
        position: absolute;
        transform-origin: center; /* 设置缩放中心 */
        transform: scale(1); /* 初始缩放比例 */
        transition: transform 0.3s ease; /* 动画效果 */
        max-width: none !important;
        cursor: none;
      }

      #canMask {
        position: absolute;
        transform-origin: center;
        transform: scale(1); /* 初始缩放比例 */
        transition: transform 0.3s ease;
      }

      .canvas_box {
        position: relative;
        font-size: 0 !important;
        width: 600px;
        height: 600px;
        /* overflow: hidden; */
        display: flex;
        justify-content: center;
        align-items: center;

        .canvas_img {
          max-width: 600px;
          height: 100%;

        }

        .canvas_imgs {
          max-width: 600px;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          //border: 1px solid #000;
          // background: transparent;
          background-size: cover; /* 使背景图像覆盖整个canvas */
          background-position: center; /* 将背景图像居中 */
          background-repeat: no-repeat; /* 防止背景图像重复 */
        }
      }

      .brush {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        color: #fafafa;
        font-size: 16px;
        background-color: rgba(0, 0, 0, .6);
        padding: 5px;
        border-radius: 3px;

        .addBtn {
          width: 22px;
          //height: 20px;
          cursor: pointer;
          font-size: 0 !important;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .slider {
          width: 100px;
          margin: 0 10px;
        }

        .Dragging {
          padding: 0 4px;
          border-radius: 3px;
          cursor: pointer;

          &.ok_drag {
            background-color: #616368;
          }

          &:hover {
            background-color: #2b2b2b;
          }
        }
      }

      .scoBox {
        display: flex;
        justify-content: space-between;
        width: 150px;
      }
    }

    .complete_btn {
      padding: 10px 0 0;
      border-top: 1px solid #353639;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .inp_Redraw {
        //margin-right: 20px;

        input {
          background: #313338 !important;
          white-space: normal;
          border: none;
          resize: none;
          height: 32px;
          padding: 0 0 0 10px;
          border-radius: 3px;
          width: 400px;
          color: #d2d2d3;
        }
      }

      .fulfil_btn {
        //margin: 0 auto;
        cursor: pointer;
        background-color: #5865f2;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        white-space: nowrap;
        user-select: none;
        height: 36px;
        width: 250px;
        border-radius: 4px;
        //margin-left: 20px;
      }
    }
  }
}
</style>